import axios from "axios"
import {VIEWERFEATURE} from "./debugMenu";
import {PartSelectableObject} from "./partSelOb";
import {SelObController} from "./controllerModules/selObController";
import {Z_OrderTable, ZIndexEntry} from "./zOrderTable";
import {controllerFor3DViewer, CurrentOwayProductProvider} from "./controller";
import {PartPatternController} from "./3dviewerModules/partPatternController";
import {ChromoLogo, SelectableObject, StockLogo} from "./selectableObjects";
import {clampValue, noop, valuesAreEqualWithinPrecision} from "../global/globalUtils";
import {EventListener, EventVerteiler} from "../global/eventVerteiler";
import {SelObTypes} from "./SelObTypes";
import {ThreeDModelLoadedEventObject} from "./OwayoLoader";
import {DrehwinkelAufSelObErmittler} from "./faceIterator";
import {HandleShaderCreator, ShaderCreator} from "./shader/OwayoShader";
import {ResourceInvalidationTriggers} from "../global/resourcemanager/resourceManager";
import {PartSelectableObjectText} from "./partSelObText";
import {PartSelectableObjectLogo} from "./partSelObLogo";
import {PartSelectableObjectChromoLogo} from "./partSelObChromoLogo";
import {OwayoJSViewerDimensionInfoObject, VIEWER_INTERACTIONMODES, WEBGL_ERROR_REASONS} from "./OwayoJsViewer";
import {owayoUtils} from "./owayoUtils";
import {GreyOutState, OwayoKonfiPart} from "./owayoPartWithSelObs";
import {PortalLine} from "./portallinie";
import {MathUtils} from "./mathUtils";
import {GlobalUtilityPainter} from "./globalUtilityPainter";
import {Snap} from "./snap";
import {ShaderInfoProviderParent} from "./shader/shaderInterfaces";
import {ModelRotatorSingleton} from "./modelRotatorSingleton";
import {SelObNewValueCalculatorafterProductChangeCalculator} from "./selObNewValueCalculatorafterProductChange";
import {FullscreenViewer} from "./3dviewerModules/fullscreen";
import {OwayoMaterialController} from "./materialController";
import {ViewerKeyboardHandler} from "./3dviewerModules/viewerKeyboardHandler";
import {CONSTANTS} from "./meta_data";
import {THREE} from "./resource/BVH.js";
import Hammer from "@egjs/hammerjs"
import {
    PartJSONParser,
    SmartGuidesJSONParser,
    SperrbezirkeJSONParser,
    TeilungsLinienJSONParser
} from "./3dviewerModules/jsonParser";
import {HINTBOXEVENTNAMES, SELOBEVENTNAMES, SELOBTAB_EVENTNAMES} from "../global/GlobalEventnames";
import {StringDictionary, Vector2, Vector2WithUV} from "./delme_globals";
import {TaskCounter} from "./taskCounter";
import {ViewerPointerDeviceHandler} from "./3dviewerModules/viewerPointerDeviceHandler";
import {ViewerZoomController} from "./3dviewerModules/viewerZoomController";
import {WebGLErrorHandler} from "./webglError";
import {Color} from "./colorObject";
import DEBUG from "./DEBUG";
import {globalsObject} from "./globalsObject";
import {PNGZipLoader} from "../global/newZipLoader";
import {deepCopy} from "../global/deepCopy";
import {
    arrayElementByKeyValue,
    arrayGetElementByNoneCaseSensitiveName,
    arrayIndexByKeyValue
} from "../global/arrayHelper";
import {logIfDebug, warnIfDebug} from "../global/logFunctions";
import {PartPattern} from "./pattern/partPattern";

import {getObject3DCoordinateOfUV} from "./MeshGeometryTools";
import {TrikotWenderKonfi} from "./wendetrikot/TrikotWenderKonfi";
import {usePalettenClusterStore} from "@k/vue/store/palettenClusterStore";

export interface OutlineInfoProvider {
    getHeightInCMFromHeightInPixelRespectingScaling(selObID, dim):number;
    getSelObScalingY(selObID):number;
    getSelObParentHeightInCM(selObID:string):number;
    getSelObParentHeightInPixel(selObID:string):number;
    getHeightInPixelsFromHeightInCMRespectingScaling(selObId, heightCM):number;
    getPartSelObById(id):PartSelectableObject|null;
}

export interface ISnapshotTaker {
    takeSnapshots(angles:number[]) : string[];
}

export interface ISelObInfoProvider {
    getAllTextObjectRelUVDimensions();
    getAllLogoObjectRelUVDimensions();
    webGLBrowserLimits;
}

export type PartForMaterial = {
    alphaMap:any;
    specularMap:any;
    bumpMap:any;
    normalMap:any;
    innenseiteAufhellen:any;
    bumpScale:any;
    normalScale:any;
    schwarzAufhellenImDruckbereich:any;
    shininess:any;
    specularMin:any;
    specular:any;
    isDroppableLegacyFromStoff:any;
    offsetRepeat:any;
    partSizeCM:{x:number, y:number};
    overlayMap:any;
    overlayIntensity:any;
    overlayHelligkeitsSummand:any;
    overlayScale:any;
    overlayAnzeigenAufFarbenIntArray:any;
    mesh:THREE.Mesh;
    name:string;
    visible:boolean;
    shadowMap:any;
    isGreyedOut:any;
    map:any;
    handleShader:any
}


export interface ViewerForMaterial {
    get modelParts():StringDictionary<PartForMaterial>;
    getPatterns(partname:string):PartPattern[]
}

export class OwayoJSKonfiViewer extends EventListener implements ISnapshotTaker, ISelObInfoProvider, OutlineInfoProvider, ShaderInfoProviderParent, ViewerForMaterial{
    get modelParts(): StringDictionary<OwayoKonfiPart> {
        return this._modelParts;
    }
    selectedObject : PartSelectableObject|null = null;
    entangledObjects : PartSelectableObject[] = [];
    handleTexture : THREE.Texture|null = null;
    public portalLines : PortalLine[] = [];
    public selObController: SelObController;
    utilityPainter : GlobalUtilityPainter;
    zOrderTable : Z_OrderTable;

    patternController:PartPatternController;
    materialController : OwayoMaterialController;

    container : HTMLElement;
    // @ts-ignore
    private _modelParts : StringDictionary<OwayoKonfiPart> = [];
    modelObjects : THREE.Mesh[] = [];
    public mouseController : ViewerPointerDeviceHandler;

    colorCodes : Color[] = [];
    interactionMode : VIEWER_INTERACTIONMODES = VIEWER_INTERACTIONMODES.NONE;
    scene : THREE.Scene;
    camera : THREE.PerspectiveCamera;
    colorValueTexture : THREE.DataTexture;
    dimensions : OwayoJSViewerDimensionInfoObject;
    renderer : THREE.WebGLRenderer;
    effect: any;
    controller : controllerFor3DViewer;
    webGLBrowserLimits: { maxTextures: any; maxViewPortDims?: any; maxVertexTextures?: any; maxCombinedTextures?: any; maxTextureSize?: any; maxCubeMapTextureSize?: any; };
    waitingForDrop  = "";
    isModelLoaded = false
    features: any;
    viewerTasks : TaskCounter;
    protected isRendering =false;
    animationRequestId: number;
    protected designTexturesTaskCounter:TaskCounter|null = null;
    protected keyBoardController: ViewerKeyboardHandler;
    zoomController: ViewerZoomController;
    protected owayoProductgetter: CurrentOwayProductProvider;
    public wender: TrikotWenderKonfi;

    constructor(controller:controllerFor3DViewer, selObController:SelObController, container : HTMLElement, owayoProductgetter:CurrentOwayProductProvider) {
        super();
        this.utilityPainter = new GlobalUtilityPainter(this);
        this.owayoProductgetter = owayoProductgetter;
        this.mouseController = new ViewerPointerDeviceHandler(container);
        this.keyBoardController = new ViewerKeyboardHandler();
        this.zoomController = new ViewerZoomController();
        this.controller = controller;
        this.container = container;

        this.scene = new THREE.Scene();
        this.colorValueTexture = OwayoJSKonfiViewer.getColorValueTextureAtConstruction();
        this.dimensions = new OwayoJSViewerDimensionInfoObject(window.innerWidth - 20, window.innerHeight- 20);

        this.patternController = new PartPatternController(this);
        this.selObController = selObController;
        this.initHandleTexture();
        this.init();

        this.zOrderTable = new Z_OrderTable();
        this.viewerTasks = new TaskCounter(
            this,
            noop,//,$this.requestGlobalBlock(),
            noop,//this.releaseGlobalBlock(),
            "global TaskCounter"
        );

        this.isRendering   = false;

        this.initInputEventHandlers();

        this.materialController = new OwayoMaterialController(this);
        OwayoJSKonfiViewer.registerPreloaderHideTask();
        this.wender = new TrikotWenderKonfi(this);
    }

    init() {
        if(EventVerteiler.resourceManager.resourceExists("initViewComponent_owayoJSViewer")) {
            return;
        }
        this.initControllerEventHandlers();
        this.initScene();
        EventVerteiler.registerResource({resourceName:"initViewComponent_owayoJSViewer", startingStati:["done"]});
    }


    public cloneCameraPosition() {
        return new THREE.Vector3(this.camera.position.x, this.camera.position.y, this.camera.position.z);
    }


    private static getColorValueTextureAtConstruction() {
        const colorValueTexture = new THREE.DataTexture(new Uint8Array(1024), 256,1, THREE.RGBAFormat);
        colorValueTexture.minFilter = THREE.NearestFilter;
        colorValueTexture.magFilter = THREE.NearestFilter;
        colorValueTexture.generateMipmaps = true;
        return colorValueTexture;
    }



    initScene() {
        // erstelle eine scene
        // erstelle eine Kamera
        // Diese stellen wir etwas weiter weg und nehmen nur einen winkel von 33°
        // dadurch wird das Modell nicht so stark in die kamera vergrößert beim Kippen,
        // als wenn wir die Kamera näher hin stellen und einen größeren Winkel nehmen.
        this.camera = new THREE.PerspectiveCamera( CONSTANTS.CAMERA_STANDARD_FOV, this.dimensions.viewer.width / this.dimensions.viewer.height, 0.01, 100 );
        this.zoomController.setCamera(this.camera);
        this.camera.position.z = 50;

        // erstelle eine Render engine, je nach dem ob wir per WebGL oder etwsa anderem Rendern.
        //
        // Unsere Modelle sind zu Detailiert um sie per Canvasrenderer zu rendern.
        // Wir werden hier in zukunft daher auf eine andere Internetseite verweisen, wenn kein
        // WebGL vorhanden ist.
        // Bis dahin geben wir erstmal eine Warnung aus.
        //
        try {
            this.renderer = new THREE.WebGLRenderer( CONSTANTS.RENDER_PARAMS );
            this.renderer.setPixelRatio( CONSTANTS.DEVICE_PIXEL_RATIO);
        } catch (e) {
            WebGLErrorHandler.handleWebGLError(this.controller.getLanguageIso(), WEBGL_ERROR_REASONS[WebGLErrorHandler.webGLFailReason()])
            return;
        }
        if (this.renderer.context.drawingBufferHeight < 10) {
            if (!DEBUG){
                WebGLErrorHandler.handleWebGLError(this.controller.getLanguageIso(), WEBGL_ERROR_REASONS.WEBGL_ERROR_FIREFOX_BUG)
            }
            return;
        }

        // Am anfang benutzen wir die gesamte grö0e als Renderimage.
        // Wenn wir später das Modell geladen haben, so können wir aus
        // Performancegründen die größe anpassen.  Das geschieht in der Funktion "CalcViewSize"
        this.renderer.setSize( this.dimensions.viewer.width, this.dimensions.viewer.height );
        // if (VIEWERFEATURE.RENDER_STEREO.isOn) {
        //     this.effect = new THREE.AnaglyphEffect( this.renderer );
        //     this.effect.setSize( this.dimensions.viewer.width, this.dimensions.viewer.height );
        // }
        this.container.appendChild( this.renderer.domElement );

        this.insertLights();
        this.appendLostContextEvents();
        this.calcViewSize();
        this.readWebGLBrowserLimits();
    }


    readWebGLBrowserLimits(){
        const gl = this.renderer.getContext();
        this.webGLBrowserLimits = {
            maxViewPortDims : gl.getParameter(gl.MAX_VIEWPORT_DIMS),
            maxTextures : gl.getParameter(gl.MAX_TEXTURE_IMAGE_UNITS),
            maxVertexTextures : gl.getParameter(gl.MAX_VERTEX_TEXTURE_IMAGE_UNITS),
            maxCombinedTextures : gl.getParameter(gl.MAX_COMBINED_TEXTURE_IMAGE_UNITS),
            maxTextureSize : gl.getParameter(gl.MAX_TEXTURE_SIZE),
            maxCubeMapTextureSize : gl.getParameter(gl.MAX_CUBE_MAP_TEXTURE_SIZE)
        }
    }


    /**
     * Die events für Contextloss werden angehängt
     */
    appendLostContextEvents(){
        const $this = this;
        this.renderer.context.canvas.addEventListener("webglcontextlost", function(event: { preventDefault: () => void; }) {
            event.preventDefault();

            if (!DEBUG){
                WebGLErrorHandler.handleWebGLError($this.controller.getLanguageIso(), 'WebGL context lost! I try to restart WebGL.');
            }
            window.cancelAnimationFrame($this.animationRequestId);
            $this.recreateRenderer();
        }, false);
    }

    private static getDirectionalLight(){
        const directionalLight = new THREE.DirectionalLight( 0xffffff );
        directionalLight.position.set( 5, 5, 25 );
        return directionalLight
    }

    insertLights() {
        this.scene.add( new THREE.AmbientLight(0x202020) );
        this.scene.add( OwayoJSKonfiViewer.getDirectionalLight() );
    }

    protected trash3DObject(object:THREE.Mesh) {

        if (object.children && object.children.length > 0) {
            for (let index = 0, len = object.children.length; index < len; index++) {
                this.trash3DObject(object.children[index]);
            }
        }
        if (object.geometry) {
            object.geometry.dispose();
        }
        if (object.material) {
            object.material.dispose();
        }
        if (object.dispose) {
            object.dispose();
        }
    }



    private deleteModelObjects() {
        let i, modelObject;

        const urlCreator = window.URL || window.webkitURL;
        for (i = 0; i < this.modelObjects.length; i++) {
            modelObject = this.modelObjects[i];
            if (modelObject.geometry) {
                modelObject.geometry.dispose();
                modelObject.geometry = null;
            }
            if (modelObject.material) {
                if (typeof(modelObject.material.uniforms) !== "undefined" && typeof(modelObject.material.uniforms.ColorTextures) !== "undefined") {
                    modelObject.material.uniforms.ColorTextures.value[0].dispose();
                    //noinspection JSUnresolvedFunction
                    urlCreator.revokeObjectURL(modelObject.material.uniforms.ColorTextures.value[0].sourceFile);
                    delete modelObject.material.uniforms.ColorTextures.value[0].image;
                }
                modelObject.material.dispose();
                modelObject.material = null;
            }
        }
    }

    private static isLight = child=>child instanceof THREE.Light;

    private removeObjectsFromScene() {
        let i, mesh;
        for (i = this.scene.children.length - 1; i > -1; i--) {
            if (!OwayoJSKonfiViewer.isLight(this.scene.children[i])) {
                mesh = this.scene.children[i];
                this.scene.remove(this.scene.children[i]);
                this.trash3DObject(mesh);
            }
        }
    }

    protected addObjectToScene(loaded3DObject) {
        const $this = this;
        const new3dObject = new THREE.Object3D();
        new3dObject.children = loaded3DObject.children.map(
            function(child){
                const mesh = new THREE.Mesh(child.geometry.clone(), child.material.clone());
                mesh.name = child.name;
                return mesh;
            }
        );

        new3dObject.position.y = 0;
        new3dObject.position.x = 0;

        this.calcViewSize();
        this.resetCameraPosition();

        new3dObject.traverse(function (child) {
            if (child instanceof THREE.Mesh) {
                child.BVHTree = THREE.LBVH.createTree(child);
                $this._modelParts[child.name] = $this.createPart(child);
                $this.modelObjects.push(child);
            }
        });
        this.scene.add(new3dObject);
    }

    public setNichtEinfaerbbaresPartImageFlagTrueOnAllParts() {
        let objectName;
        for (objectName in this._modelParts) {
            this._modelParts[objectName].hasZentralesAbgelegtesNichtEinfaerbbaresPartImage = true;
        }
    }

    changeColor(colorCode, hexValue) {
        let colorObject, index, masterColor;

        for (index = 0; index < this.colorCodes.length; index += 1){
            if (this.colorCodes[index].colorCode === colorCode) {
                colorObject = this.colorCodes[index];
                break;
            }
        }
        if(typeof(colorObject) === "undefined") {
            console.warn(colorCode + " nicht gefunden");
            return;
        }
        if (colorObject.isHideable) {
            masterColor = arrayElementByKeyValue(this.colorCodes, "colorCode", colorObject.dependentOn);
            if (masterColor === null ) {
                logIfDebug("Mist, masterColor war null");
                return;
            }
            if (hexValue === "none") { //Abhängigkeit einschalten
                if (arrayIndexByKeyValue(masterColor.dependentColors, "colorCode", colorObject.colorCode) === -1) {
                    masterColor.dependentColors.push(colorObject);
                    colorObject.colorValue = masterColor.colorValue;
                    colorObject.blendToBackground = true;
                }
            } else {
                index = arrayIndexByKeyValue(masterColor.dependentColors, "colorCode", colorObject.colorCode);
                if (index > -1) {
                    masterColor.dependentColors.splice(index,1);
                }
                colorObject.setValueFromHex(hexValue);
                colorObject.blendToBackground = false;
            }

        } else {
            colorObject.setValueFromHex(hexValue);
        }

        if (colorObject.dependentColors.length === 0 && ! colorObject.isHideable) {
            OwayoJSKonfiViewer.updateSingleColorInColorValueTexture(this.colorValueTexture, this.colorCodes, colorCode);
        } else {
            OwayoJSKonfiViewer.updateColorValueTexture(this.colorValueTexture, this.colorCodes);
        }
        this.render();
    }

    resetCameraPosition()
    {
        const maxModelDimension = this.dimensions.getMaxModelDimension();

        // this.camera.position.z = (maxModelDimension*1.9) + (this.dimensions.model.z/2) ;
        this.camera.position.z = this.getCameraPositionThatSeesAllOfTheModel(maxModelDimension);
        // 	Wir gehen hier nicht auf den kleinsten möglichen Bereich (/2), sondern auf einen etwas größeren (/1.5)
        // damit wir Rundungsfehler etc. umgehen.
        this.camera.near = this.camera.position.z - (maxModelDimension / 1.1);
        this.camera.far = this.camera.position.z + (maxModelDimension / 1.5);

        // Update die Kamera mit den neuen Parametern
        this.camera.updateProjectionMatrix();
        this.render();
    }

    private getCameraPositionThatSeesAllOfTheModel(maxModelDimension:number) {

        let tanWinkel = this.camera.fov/2;
        // Ohne die nächsten Zeilen schauts besser aus, keiner weiß warum die da war...
        // if(valuesAreEqualWithinPrecision(maxModelDimension, this.dimensions.model.x)) {        //
        //     tanWinkel *=this.camera.aspect
        // }
        return (maxModelDimension/2)/Math.tan(tanWinkel*Math.PI / 180) + Math.max(4, this.dimensions.model.z) ;
    }

    render()
    {
        //render
        const $this = this;
        if (CONSTANTS.FPS_LIMIT <=0) {
            window.requestAnimationFrame( function(){$this.doRender();} );
            return;
        }

        if (this.isRendering) {
            return;
        }
        this.isRendering = true;

        setTimeout(function(){
            $this.isRendering = false;
            $this.animationRequestId = window.requestAnimationFrame( ()=>$this.doRender());
        }, 1000/ CONSTANTS.FPS_LIMIT );
    }

    private clearScene() {
        for (let i = 0, len = this.scene.children.length; i < len; i++) {
            this.scene.remove(this.scene.children[0]);
        }
        this.scene = new THREE.Scene();
    }

    private clearModelObjects() {
        for (let i = 0, len = this.modelObjects.length; i < len; i++) {
            this.modelObjects[i].geometry.dispose();
        }
        this.modelObjects = [];
    }

    private recreateHandleTexture() {
        const oldImage = this.handleTexture.image;
        this.handleTexture.dispose();
        this.handleTexture = new THREE.Texture(oldImage);
        this.handleTexture.needsUpdate = true;
    }

    private recreateModelParts() {
        for (const partName in this._modelParts) {
            const part = this._modelParts[partName];

            part.shaders = [];
            part.shaders[0] = new THREE.MeshLambertMaterial();

            const newMesh = new THREE.Mesh(new THREE.BufferGeometry(), part.shaders[0]);


            if (typeof(part.mesh.geometry.index) !== "undefined") {
                newMesh.geometry.addIndex(new THREE.BufferAttribute(part.mesh.geometry.index.array, 1));
            }
            newMesh.geometry.addAttribute("position", new THREE.BufferAttribute(part.mesh.geometry.attributes.position.array, 3));
            newMesh.geometry.addAttribute("uv", new THREE.BufferAttribute(part.mesh.geometry.attributes.uv.array, 2));

            newMesh.geometry.buffersNeedUpdate = true;
            newMesh.geometry.uvsNeedUpdate = true;
            newMesh.geometry.verticesNeedUpdate = true;

            newMesh.geometry.computeFaceNormals();
            newMesh.geometry.computeVertexNormals();
            newMesh.geometry.computeBoundingBox();
            newMesh.geometry.computeBoundingSphere();

            newMesh.name = partName;

            part.mesh = newMesh;
            this.scene.add(newMesh);
            this.modelObjects.push(newMesh);


            const oldImage = part.colorTexture.image;
            part.colorTexture.dispose();
            part.colorTexture = new THREE.Texture(oldImage);
            part.colorTexture.minFilter = THREE.NearestFilter;
            part.colorTexture.magFilter = THREE.NearestFilter;
            part.colorTexture.needsUpdate = true;
        }
    }

    static updateSingleColorInColorValueTexture(texture : THREE.DataTexture, colorCodes : Color[], colorCodeToChange = null) {
        const colorObject = arrayElementByKeyValue(colorCodes, "colorCode", colorCodeToChange);
        if (colorObject !== null) {
            OwayoJSKonfiViewer.writeColorObjectToTextureDataArray(colorObject, texture.image.data);
        }
        texture.needsUpdate = true;
    }

    protected static updateColorValueTexture(texture : THREE.DataTexture, colorCodes : Color[]) {
        for (let i = 0, len = colorCodes.length; i < len; i++) {
            OwayoJSKonfiViewer.writeColorObjectToTextureDataArray(colorCodes[i], texture.image.data);
        }
        texture.needsUpdate = true;
    }

    protected static InitBildPalettenTexturen(colors : Color[]){
        const palettenStore = usePalettenClusterStore();
        for (let i = 0, len = colors.length; i < len; i++) {
            if (colors[i].palette!==null){
                const PalettenFarben = palettenStore.getPalette(colors[i].palette);
                const ColorObj = (PalettenFarben!==null) ? arrayElementByKeyValue(
                    PalettenFarben, "RGBHex", colors[i].getValueAsHex()
                ) : null;
                const TexturenImage = (ColorObj!==null) ? ColorObj.TexturenImage : "";

                if (TexturenImage!==""){
                    EventVerteiler.broadcast("loadBildPalettenTexturenImage", {colorCode: colors[i].colorCode, TexturenImage: TexturenImage});
                }
            }
        }
    }

    private static writeColorObjectToTextureDataArray(colorObject:Color, data:ImageData) {
        const color = colorObject.createVec4();
        const index = colorObject.colorCodeNr * 4;
        data[index] = color.x * 255;
        data[index + 1] = color.y * 255;
        data[index + 2] = color.z * 255;
        data[index + 3] = color.w * 255;
    }

    /**
     * Die Kamera wird zur Position x,y,z verschoben (ruft animateCamera auf)
     */
    moveCameraToPosition(x, y, z, duration) {
        const delta = {x: x - this.camera.position.x, y: y - this.camera.position.y, z: z - this.camera.position.z};

        this.moveObject({
            objectToMove: this.camera,
            stepsRendered: 0,
            startPos: OwayoJSKonfiViewer.cloneXYZObject(this.camera.position),
            delta: delta,
            framesToRender: duration * CONSTANTS.CAMERA_MOVE_FPS
        });
    }

    public static cloneXYZObject(obj:{x,y,z}) {
        return {x:obj.x, y:obj.y, z:obj.z};
    }

    private static easeInOutQuint(verstricheneFrames, startWert, diffToZielwert, zeit) {

        verstricheneFrames /= zeit / 2;
        if (verstricheneFrames < 1) {
            return diffToZielwert / 2 * verstricheneFrames * verstricheneFrames * verstricheneFrames * verstricheneFrames * verstricheneFrames + startWert;
        }
        verstricheneFrames -= 2;
        return diffToZielwert / 2 * (verstricheneFrames * verstricheneFrames * verstricheneFrames * verstricheneFrames * verstricheneFrames + 2) + startWert;
    }

    moveObject(parameters) {
        const $this = this;
        if (typeof(parameters.animationFunction) !== "function") {
            parameters.animationFunction = OwayoJSKonfiViewer.easeInOutQuint;
        }
        parameters.objectToMove.position.x = parameters.animationFunction(
            parameters.stepsRendered,
            parameters.startPos.x,
            parameters.delta.x,
            parameters.framesToRender
        );
        parameters.objectToMove.position.y = parameters.animationFunction(
            parameters.stepsRendered,
            parameters.startPos.y,
            parameters.delta.y,
            parameters.framesToRender
        );
        parameters.objectToMove.position.z = parameters.animationFunction(
            parameters.stepsRendered,
            parameters.startPos.z,
            parameters.delta.z,
            parameters.framesToRender
        );

        this.render();
        parameters.stepsRendered ++;

        if (parameters.stepsRendered < parameters.framesToRender) {
            setTimeout(function(){$this.moveObject(parameters);}
                , 1000 / CONSTANTS.CAMERA_MOVE_FPS);
        }
    }

    /**
     * Das Model wurde gedreht.
     * @param {number}	xAxisRotation		Achtung! Bewegung auf x Achse der Maus dreht um Y Achse und umgekehrt!
     * @param {number}	yAxisRotation		Achtung! Bewegung auf x Achse der Maus dreht um Y Achse und umgekehrt!
     */
    public updateModelRotation(xAxisRotation,yAxisRotation) {
        let i, len;
        const maxNeigung = this.owayoProductgetter.getCurrentOwayoProduct().maxNeigungBogenmass,
            maxDrehung = this.owayoProductgetter.getCurrentOwayoProduct().maxDrehungBogenmass;

        if (maxNeigung >= 0) {
            xAxisRotation = clampValue(xAxisRotation, -maxNeigung, maxNeigung);
        }

        yAxisRotation = yAxisRotation % (Math.PI*2);
        if (maxDrehung >= 0) {
            yAxisRotation = clampValue(yAxisRotation, -maxDrehung, maxDrehung);
        }
        for (i = 0, len = this.modelObjects.length; i < len; i += 1 ) {
            this.modelObjects[i].rotation.x = xAxisRotation;
            this.modelObjects[i].rotation.y = yAxisRotation;
        }
        this.render();
    }

    private static registerPreloaderHideTask = ()=>EventVerteiler.createTask("hidePreloader")
        .discardAfterExecution()
        .when("designtexturesLoaded", "done")
        .thenDo(function(){OwayoJSKonfiViewer.hidePreloader();});

    private initHandleTexture() {
        const $this = this;

        this.handleTexture = new THREE.Texture();
        this.handleTexture.minFilter = THREE.LinearFilter;
        this.handleTexture.generateMipmaps = false;
        this.handleTexture.image = new Image();
        this.handleTexture.image.onload = function () {
            ($this.handleTexture as THREE.Texture).needsUpdate = true;
        };
        this.handleTexture.image.src = "/konfigurator_html/img/handles.png";
    }

    resetViewerData() {
        this.utilityPainter.clearAllLayers();

        this.interactionMode = VIEWER_INTERACTIONMODES.NONE;
        this.waitingForDrop = "";

        this.isModelLoaded = false;

        this.removeObjectsFromScene();
        this.deleteModelObjects();
        this.modelObjects   = [];
        THREE.Cache.clear();
        for (const partName in this._modelParts ) {
            this._modelParts[partName].dispose();
        }
        this.colorValueTexture.dispose();
        this._modelParts     = {};
        this.patternController.clear();
        this.selectedObject = null;
        this.entangledObjects = [];

        this.portalLines = [];
        this.utilityPainter.resetFading();
        this.utilityPainter  = new GlobalUtilityPainter(this);
        this.zOrderTable    = new Z_OrderTable();
    }

    private loadDesignEventHandler(design, model, schnitt, features, herstellerlogosEntfernt) {
        this.interactionMode = VIEWER_INTERACTIONMODES.NONE;
        this.waitingForDrop = "";
        const zoomOrigin = this.zoomController.getZoomOrigin();
        this.moveCameraToPosition(zoomOrigin.x,zoomOrigin.y,this.camera.position.z, 0.5);
        this.zoomController.resetZoomLevel();
        this.loadDesign(design, model, schnitt, features, herstellerlogosEntfernt);
    }

    private selObInsertedEventHandler(selOb:SelectableObject, zIndex, maybeAppendedToEntry) {
        if (arrayIndexByKeyValue(this._modelParts[selOb.partName].selectableObjects, "id", selOb.id) > -1) {
            logIfDebug("object already exists");
            return;
        }
        this.interactionMode = VIEWER_INTERACTIONMODES.NONE;
        this.waitingForDrop = "";
        this._modelParts[selOb.partName].pendingTasks.addTasks(1);
        this.insertSelOb(selOb, zIndex, maybeAppendedToEntry);
        this.liftGreyOutOnNonDroppableParts();
    }

    private selObCreatedEventHandler(id) {
        this.waitingForDrop = id;
        this.interactionMode = VIEWER_INTERACTIONMODES.WAIT_FOR_DROP;
        this.clearSelection();
        this.greyOutNotDroppableParts();
    }

    private selObDeletedEventHandler(id) {
        this.waitingForDrop = "";
        this.interactionMode = VIEWER_INTERACTIONMODES.NONE;
        this.deleteSelOb(id);
        this.clearSelection();
    }

    private pleaseTakePicturesEventHandler(angles, callback) {
        if (typeof(this.modelObjects[0]) === "undefined") {
            return;
        }
        if(typeof(angles) === "undefined") {
            const OFFSET = -25;
            angles = [-OFFSET, +OFFSET, 180 - OFFSET, 180 + OFFSET];
        }
        this.controller.saveEntwurfPreviewPics(this.takeSnapshots(angles), callback);
    }
    private giveMeScreenshots(callback) {
            // const OFFSET = -25;
            // const angles = [-OFFSET, +OFFSET, 180 - OFFSET, 180 + OFFSET];
            const angles = [0, 90, 180, 270];
            callback(this.takeSnapshots(angles))
    }

    private static taskCounterTaskFinishedEventHandler(taskName) {
        if (taskName === "loadColorTexture") {
            EventVerteiler.broadcast("checkAllColorsAndChangeChromoLogoIfNecessaryEvent");
        }
    }



    private toolCategoryOpenedEventHandler(category) {
        if (this.selectedObject !== null) {
            if(this.selectedObject.type === SelObTypes.TEXT && category !== "text") {
                this.clearSelection();
                return;
            }
            if (SelObTypes.isLogo(this.selectedObject.type) && category !== "logo") {
                this.clearSelection();
                return;
            }
        }
    }



    private selObSelectedFromRahmenHandler(id) {
        const selOb = this.getPartSelObById(id);
        if(selOb !== null) {
            this.rotateModelToSelOb(selOb);
            this.partSelObSelected(selOb);
        }
    }

    private DISPLAY_SELOB_IN_VIEWERHandler(id) {

        const selOb = this.getPartSelObById(id);
        if(selOb !== null) {
            this.rotateModelToSelOb(selOb);
        }
    }

    private threeDModelLoadedEventHandler(object, model, cut, features, dimensions) {
        this.resetViewerData();
        OwayoJSKonfiViewer.resetTexture(this.colorValueTexture);
        OwayoJSKonfiViewer.updateColorValueTexture(this.colorValueTexture, this.colorCodes);
        this.dimensions.model = dimensions;
        this.onLoadedModel(object, model, cut, features);
    }

    private initColorsEventHandler(colorCodes) {
        this.colorCodes = colorCodes;
        OwayoJSKonfiViewer.updateColorValueTexture(this.colorValueTexture, this.colorCodes);
    }


    protected initControllerEventHandlers() {
        this
            .addEventListener("loadDesignEvent", (data)=>this.loadDesignEventHandler(data.design, data.model, data.schnitt, data.features, data.herstellerlogosEntfernt))
            .addEventListener(SELOBEVENTNAMES.INSERTED,(data)=>this.selObInsertedEventHandler(data.selOb, data.zIndex, data.maybeAppendedToEntry))
            .addEventListener(SELOBEVENTNAMES.CREATED, (data)=>this.selObCreatedEventHandler(data.id))
            .addEventListener(SELOBEVENTNAMES.DELETED, (data)=>this.selObDeletedEventHandler(data.id))
            .addEventListener(SELOBEVENTNAMES.CHANGED, (data)=>this.selObChanged(data.selOb, data.changedProperties))
            .addEventListener(SELOBEVENTNAMES.SELECTED, (selOb)=>this.selObFromControllerSelected(selOb))
            .addEventListener(SELOBEVENTNAMES.SELECTION_CLEARED, ()=>this.clearSelection())
            .addEventListener(SELOBEVENTNAMES.CLONE_DELETED, (data)=>this.deleteClone(data.origId, data.cloneId))
            .addEventListener(SELOBEVENTNAMES.FLOATING_CHANGED, (data)=>(this.getPartSelObById(data.id) as PartSelectableObject).floating = data.floating)
            .addEventListener(SELOBEVENTNAMES.DISPLAY_SELOB_IN_VIEWER, (id)=>this.DISPLAY_SELOB_IN_VIEWERHandler(id))
            .addEventListener("clonedSelObChangedEvent", (data)=>this.selObChanged(data.selOb, data.changedProperties, CONSTANTS.I_AM_A_CLONE))
            .addEventListener("colorSelectedEvent", ()=>this.clearSelection())
            .addEventListener("initSelObsEvent", (data)=>this.loadSelectableObjectArray(data.objects, JSON.parse(data.zOrderJSON)))
            .addEventListener("cloneCreatedEvent", (data)=>this.createClone(data.origId, data.clone))
            .addEventListener("zOrderChangedEvent", (data)=>this.zOrderChanged(data.changed, JSON.parse(data.completeJSONList)))
            .addEventListener("changedSelObScaleUniformEvent", (data)=>this.changeSelObScaleUniform(data.id, data.operator))
            .addEventListener("pleaseTakePicturesEvent", (data)=>this.pleaseTakePicturesEventHandler(data.angles, data.callback))
            .addEventListener("taskCounterTaskFinishedEvent", (data)=>OwayoJSKonfiViewer.taskCounterTaskFinishedEventHandler(data.taskName))
            .addEventListener("pleaseTakePicturesEventAndReturnThemToMe", (callback)=>this.giveMeScreenshots(callback))
            .addEventListener(SELOBTAB_EVENTNAMES.TABOPENED, (data)=>this.toolCategoryOpenedEventHandler(data.category))
            .addEventListener("giveMePartSizesEvent", (callback)=>this.sendPartSizeInfoToController(callback))
            .addEventListener("tryInsertingObjectAfterProductChangeEvent", (data)=>this.tryInsertingSelObAfterProductChange(data.selOb, data.oldPartDimensionsCm, data.zIndex))
            .addEventListener("recreateAllShadersEvent", ()=>this.recreateAllShaders())
            .addEventListener("executeZOrderOperation", (direction)=>this.zOrderOperation(direction))
            .addEventListener("zoomModelEvent", (direction)=> direction === "in" ? this.zoomController.zoomIn() : this.zoomController.zoomOut())
            .addEventListener("rotateModelEvent", (data)=>this.rotateModelEventHandler(data.axis, data.direction, data.amount))
            // .on("reloadSelObEvent", (event, data)=>this.reloadSelObEventHandler(data.selOb))
            .addEventListener("patchZOrderHolesEvent", ()=>this.zOrderTable.patchHoles())
            .addEventListener("calcViewsizeEvent", ()=>this.calcViewSize())
            .addEventListener("selObSelectedFromRahmen", (id)=>this.selObSelectedFromRahmenHandler(id))
            .addEventListener("DreiDPartsnachBedarfEinUndAusblendenEvent", (data)=>this.DreiDPartsnachBedarfEinUndAusblenden(data.features))
            .addEventListener("threeDModelLoadedEvent", (data:ThreeDModelLoadedEventObject)=>{
                this.threeDModelLoadedEventHandler(data.object, data.model, data.cut, data.features, data.dimensions)
            })
            .addEventListener("initColorsEvent", (data)=>this.initColorsEventHandler(data.colorCodes))
            .addEventListener("colorChangedEvent", (data)=>this.changeColor(data.colorCode, data.colorHexValue))
            .addEventListener("initNewEntwurfEvent", OwayoJSKonfiViewer.showPreloader)
            .addEventListener("entwurfLoadingEvent", OwayoJSKonfiViewer.showPreloader)
            .addEventListener("onlyInjectColorObjectsIntoEntwurfEvent", OwayoJSKonfiViewer.hidePreloader)
            .addEventListener("loadBildPalettenTexturenImage", (data)=>this.setTexturenImageToPart(data.colorCode, data.TexturenImage))
            .addEventListener("paintedOnHandleAndGuideLayerEvent", (partname)=>this.utilityPainter.addToNonEmptyLayers(this._modelParts[partname].handleAndGuideLayer))
            .addEventListener("colorsInitializedEvent", ()=>this.patternController.broadCastAllPreviewSVGs())
            .addEventListener("SelObBackupInsertionEvent", ()=>{
                ModelRotatorSingleton.rotateModelToTargetAngleDegree(this, 0);
            })
            .addEventListener("doABarrelRollEvent", ()=>this.doABarrelRoll())
            .addEventListener("requestMotivBereich", (data:{part:string})=>{
                if(this._modelParts[data.part] === undefined) {
                    return null;
                }
                return this._modelParts[data.part].motivBereich;
            })
            .addEventListener("einmalWendenBitte", ()=>this.wender.einmalWendenBitte())
        ;
    }

    private rotateModelEventHandler(axis:"x"|"y", direction:"up"|"down"|"left"|"right", amount:number|undefined) {
        const rotation = this.getModelRotation();
        if (axis === "x") {
            rotation.x += direction === "up" ? -CONSTANTS.ONE_DEGREE : CONSTANTS.ONE_DEGREE;
        } else {
            if (typeof amount === "undefined") {
                amount = CONSTANTS.ROTATEMODEL_ON_BUTTONPRESS;
            }
            rotation.y += direction === "left" ? amount : -amount;
        }
        this.updateModelRotation(rotation.x, rotation.y)
    }

    private static resetTexture(texture:THREE.Texture) {
        texture.dispose();
        texture = new THREE.DataTexture(new Uint8Array(1024), 256,1, THREE.RGBAFormat);
        texture.minFilter = THREE.NearestFilter;
        texture.magFilter = THREE.NearestFilter;
        texture.generateMipmaps = false;
    }

    private rotateModelToSelOb(selOb:PartSelectableObject) {

        const winkel = DrehwinkelAufSelObErmittler.getDrehWinkel(selOb);
        if(isNaN(winkel) || Math.abs(winkel) < Math.PI / 16) {
            return;
        }
        const currentRotation = this.getModelRotation();
        this.rotateToTargetAngleDegree((currentRotation.y + winkel)*180/Math.PI);
    }

    private tryLoadingMaterialWithOwnNameForPartsWithoutMaterial() {
        let part;
        for (const partName in this._modelParts) {
            part = this._modelParts[partName];
            if (!part.owayoMaterial.stoff) {
                this.materialController.requestMaterial(part.name, part.name);
                part.owayoMaterial.stoff = part.name;
            }
        }
        return part;
    }

    private getPart(partName) {
        const name = owayoUtils.getCleanPartName(partName);
        let part = this._modelParts[name];

        // Wir haben den Part nicht gefunden. Jetzt kann es aber sein, dass der Part
        // mal wieder eine groß/klein-Schwäche hat.
        if (!part) {
            part = arrayGetElementByNoneCaseSensitiveName(this._modelParts, name);
        }
        if(!part) {
            part  =this._modelParts[name + "_optional"];
        }
        return part;
    }

    private initMaterials(partMaterials, features) {

        const $this = this;
        partMaterials.forEach(function(partMaterial) {
            const part = $this.getPart(partMaterial.Part);
            if(!part) {
                logIfDebug('Part wurde nicht gefunden um ihm einen Stoff zu geben: ' + partMaterial.Part);
                return;
            }
            if ( partMaterial.Material ) {
                part.owayoMaterial.stoff = partMaterial.Material;
            } else {
                const feature = arrayElementByKeyValue(features, "featuredObject", partMaterial.MaterialFeaturedObject);
                if (feature !== null) {
                    part.owayoMaterial.stoff = feature.feature;
                } else {
                    logIfDebug(part.name + " hatte kein Material");
                    part.owayoMaterial.stoff = "data_error_no_material_for_"+part.name;
                }
            }

            // Wenn ein MaterialColorCode eingetragen ist, so merken wir uns diesen.
            if (partMaterial.MaterialColorCode !== null) {
                part.owayoMaterial.colorCode = partMaterial.MaterialColorCode;
            }


            $this.materialController.requestMaterial( part.name, part.owayoMaterial.stoff );


        });
        this.tryLoadingMaterialWithOwnNameForPartsWithoutMaterial();
    }

    private zOrderChanged(changedIdsWithAlwaysOnTop, completeList:Array<Array<ZIndexEntry>>) {
        const partsWithChanges:OwayoKonfiPart[] = [];

        this.zOrderTable.setValues(completeList);

        for (let i=0, len = changedIdsWithAlwaysOnTop.length; i < len; i++) {
            const part = (this.getPartSelObById(changedIdsWithAlwaysOnTop[i].id) as PartSelectableObject).getParent();
            const changeHappened = part.orderSelObsByZIndex();
            if (changeHappened) {
                partsWithChanges.push(part);
            }
        }
        this.createShadersOnPartsWithChanges(partsWithChanges);

        this.placeHandlesOnSelectedObjectAndClones();
        this.render();
    }

    private createShadersOnPartsWithChanges = (partsWithChanges:OwayoKonfiPart[])=>partsWithChanges.forEach(
        part=>ShaderCreator.createShaders(part, this.getPatterns(part.name)));

    private placeHandlesOnSelectedObjectAndClones() {
        (this.selectedObject as PartSelectableObject).placeAppropriateHandles();
        for (let i = 0, len = this.entangledObjects.length; i < len; i++) {
            this.entangledObjects[i].placeAppropriateHandles();
        }
    }

    private initInputEventHandlers() {

        const $this = this;

        window.addEventListener( 'resize',()=>this.calcViewSize(), false );

        //damit auch wenn wir ausserhalb des Divs die Maus loslassen z.B. Rotieren aufhört
        //binden wir den Handler auf das gesamte Dokument
        document.addEventListener( 'touchend',()=>this.onDocumentMouseUp(), false);
        document.addEventListener( 'mouseup', ()=>this.onDocumentMouseUp(), false );
        (this.container.parentElement as HTMLElement).addEventListener('dblclick',()=>this.doDblClick());

        // @ts-ignore
        const mc = new Hammer(this.container);
        const pinch = new Hammer.Pinch();
        const rotate = new Hammer.Rotate();
        pinch.recognizeWith(rotate);
        mc.add([pinch, rotate]);
        mc.on("pinch", function(event) {
            $this.zoomController.handlePinch(event);
        });

        const changeFullScreen = ()=>FullscreenViewer.changeFullScreen(this);
        if (FullscreenViewer.available()) {
            document.addEventListener("webkitfullscreenchange"  , changeFullScreen, false);
            document.addEventListener("mozfullscreenchange"     , changeFullScreen, false);
            document.addEventListener("fullscreenchange"        , changeFullScreen, false);
        }

    }

    private loadSnapLines(cut, model, design) {

        const $this = this;
        axios.get("/konfigurator_php/designmodul/getSnapLines.php?cut=" + cut + "&model=" + model+ "&design=" + design)
            .then(response=>$this.parseSmartguidesJSON(response.data))
            .catch(()=>{
                EventVerteiler.handleErrorTranslated("ajaxFail", "getSnapLines",
                    "konf_error_fileMissing",
                    "(snaplines.json)");
            })
    }


    private setPartVisibility(einUndAuszublendendeDreiDParts:string[]) {
        // Manche Features schalten Parts ab. z.B.: ohne Tasche (-Bag);
        const shouldBeMadeInvisible = partName=>einUndAuszublendendeDreiDParts.indexOf('-' + partName) > -1;
        // Manche Features schalten Parts die mit "_optional" enden hinzu. Grundsätzlich sind erstmal alle _optional Parts abgeschaltet.
        const optionalPartShouldBeVisible = partName=>einUndAuszublendendeDreiDParts.indexOf(partName.replace(/_optional$/, ""))> -1;
        const invisibleParts = [] as string[];
        for (const partName in this._modelParts) {
            const part = this._modelParts[partName] as OwayoKonfiPart;
            part.setVisibility(!shouldBeMadeInvisible(partName));
                if(shouldBeMadeInvisible(partName)) {
                    invisibleParts.push(partName);
                }
            if (part.name.endsWith('_optional')) {
                part.setVisibility(optionalPartShouldBeVisible(partName));
                    if(!optionalPartShouldBeVisible(partName)) {
                        invisibleParts.push(partName);
                    }
                }
            }
        if(invisibleParts.length>0) {
            EventVerteiler.broadcast("PartsWurdenAusgeblendetEvent", {invisibleParts})
        }

    }

    private DreiDPartsnachBedarfEinUndAusblenden(features){
        let einzublendendeDreiDParts = [], i;

        for (i = 0; i < features.length; i += 1) {
            if (features[i].einzublendendeDreiDParts) {
                einzublendendeDreiDParts = einzublendendeDreiDParts.concat(features[i].einzublendendeDreiDParts.split(';'));
            }
        }
        this.setPartVisibility(einzublendendeDreiDParts);
    }

    private loadPartMapsIfNeeded() {

        let partName, part, tmpName;

        for (partName in this._modelParts) {
            part = this._modelParts[partName];

            // Etiketten etc. werden nur einmal geladen.
            if (part.visible && part.hasZentralesAbgelegtesNichtEinfaerbbaresPartImage && !part.map) {
                this.viewerTasks.addTasks(1);

                tmpName = part.name;
                if (/\.\d{3}$/.test(tmpName)) {
                    tmpName = tmpName.substring(0, tmpName.length - 4);
                }
                THREE.ImageUtils.crossOrigin = '';
                part.map = THREE.ImageUtils.loadTexture(CONSTANTS.PART_TEXTURE_PATH + tmpName + '.png');

                ShaderCreator.createShaders(part, this.getPatterns(partName));

                this.viewerTasks.taskFinished();
            }
        }
    }


    private createDesignTextureTaskCounter(numberofentries) {
        EventVerteiler.resourceManager.executeInvalidation(ResourceInvalidationTriggers.DESIGNCHANGED);
        this.designTexturesTaskCounter = new TaskCounter(
            this,
            noop,
            ()=>{
                EventVerteiler.registerResource(
                    {
                        resourceName:"designtexturesLoaded",
                        invalidatedWhen:[ResourceInvalidationTriggers.PRODUCTCHANGE, ResourceInvalidationTriggers.DESIGNCHANGED],
                        startingStati:["done"]
                    }
                );
                EventVerteiler.broadcast("checkAllColorsAndChangeChromoLogoIfNecessaryEvent");
                OwayoJSKonfiViewer.InitBildPalettenTexturen(this.controller.getEntwurfColorObjects());
            },
            "owayoJSViewer"
        );
        this.designTexturesTaskCounter.addTasks(numberofentries);
    }

    private loadDesignColorImages( cut : string, model : string, design :string, ohneHerstellerlogos : boolean = false) {
        const urlCreator = window.URL || window.webkitURL;
        const designDir = ohneHerstellerlogos ? "designs_ohl" : "designs";
        const url = CONSTANTS.MODEL_PATH + cut + "/" + model + "/" + designDir + "/" + design + '.fish';
        EventVerteiler.resourceManager.executeInvalidation(ResourceInvalidationTriggers.DESIGNCHANGED);
        PNGZipLoader.load(url, [], (fileName, image)=>this.processLoadedDesignImage(urlCreator, design, fileName, image),
            (numberofentries)=>this.createDesignTextureTaskCounter(numberofentries))
            .then(()=>{
                EventVerteiler.registerResource(
                    {
                        resourceName:"designtexturesLoaded",
                        invalidatedWhen:[ResourceInvalidationTriggers.PRODUCTCHANGE, ResourceInvalidationTriggers.DESIGNCHANGED],
                        startingStati:["done"]
                    }
                );
                EventVerteiler.broadcast("checkAllColorsAndChangeChromoLogoIfNecessaryEvent");
                OwayoJSKonfiViewer.InitBildPalettenTexturen(this.controller.getEntwurfColorObjects());
            });
    }

    private processLoadedDesignImage(urlCreator, design, fileName, image) {
        let partName,
            isShadowImage = false;

        const regexp = new RegExp("^" + design + "_");
        partName = fileName.replace(regexp, "");

        partName = partName.replace(/\.png$/, "");


        if (partName.indexOf("_shadow") > -1) {
            isShadowImage = true;
            partName = partName.replace(/_shadow$/, "");
        }

        const part = this._modelParts[partName];
        if (typeof(part) === "undefined") {
            (this.designTexturesTaskCounter as TaskCounter).taskFinished();
            return;
        }

        this.viewerTasks.addTasks(1, "loadColorTexture");

        if (isShadowImage) {
            (this.designTexturesTaskCounter as TaskCounter).taskFinished();
            part.loadShadowTexture( urlCreator.createObjectURL(image) );
        } else {
            part.loadPartColor( urlCreator.createObjectURL(image), (this.designTexturesTaskCounter as TaskCounter) );
        }

    }

    private loadDesign(design, model, cut, features, ohneHerstellerlogos)
    {
        this.loadSnapLines(cut, model, design);
        this.DreiDPartsnachBedarfEinUndAusblenden(features);
        this.loadPartMapsIfNeeded();
        this.loadDesignColorImages( cut, model, design,ohneHerstellerlogos);
        this.render();
    }

    private setTexturenImageToPart(colorcode, TexturenImage){
        const url = [CONSTANTS.HILFSMATERIAL__PATH, this.owayoProductgetter.getCurrentOwayoProduct().cut, TexturenImage].join("/");
        let partName = arrayElementByKeyValue(
            this.owayoProductgetter.getCurrentOwayoProduct().colorCodes,
            "colorCode",
            colorcode
        ).PartnameFuerTexturenExport;

        partName = partName.replace(" ", "");
        const part = this._modelParts[partName];

        if (typeof (part) !== "undefined"){
            part.hasZentralesAbgelegtesNichtEinfaerbbaresPartImage = true;
            this.viewerTasks.addTasks(1);
            THREE.ImageUtils.crossOrigin = '';
            part.map = THREE.ImageUtils.loadTexture(url);
            ShaderCreator.createShaders(part, this.getPatterns(partName));
            this.viewerTasks.taskFinished();
        }
    }


    private parseSmartguidesJSON(smartguidesJSON) {
        this.utilityPainter.removeSnaps("part", "notPortalLines");
        this.utilityPainter.snaps = SmartGuidesJSONParser.parseSmartguidesJSON(smartguidesJSON, this._modelParts)
            .concat(this.utilityPainter.snaps);
    }

    /**
     * Es kann gut sein, dass die PortalLinien erst geladen werden, nachdem die SelectableObjects geladen wurden. Dann muss das klonen jetzt passieren.
     */
    public checkObjectsAfterPortalLineLoad() {
        this.portalLines.forEach((l, index)=>this.checkObjectsForPortalLine(l, index))
    }

    private checkObjectsForPortalLine(portalLine: PortalLine, portalLineNumber) {
        const partNames = portalLine.getPartNames();
        const anzParts = partNames.length;
        let i;
        for (i = 0; i < anzParts; i++) {
            this.checkPartSelObsOnPartForPortallinie(this._modelParts[partNames[i]], portalLine, portalLineNumber);
        }
    }

    private checkPartSelObsOnPartForPortallinie(part: OwayoKonfiPart, portalLine: PortalLine, portalLineNumber) {
        const selObsArray = part.selectableObjects;
        const anzSelObs = selObsArray.length;
        let i;
        for (i = 0; i < anzSelObs; i++) {
            //Die nächstge Abfrage ist ein Bugfix, da ich kein Objekt klonen sollte, dass noch nicht fertig geladen ist.
            //das geschieht dann in "imageObjectLoaded"
            if (selObsArray[i].textureSize.x === 0) {
                continue;
            }
            const array = selObsArray[i].clonedByPortalLineNumber;
            if (portalLine.intersectsObject(selObsArray[i]) && array.indexOf(portalLineNumber) === -1) {
                selObsArray[i].clonedByPortalLineNumber.push(portalLineNumber);
                const cloneValues = portalLine.calculateCloneValues(selObsArray[i]) as {id,part,translation, rotation, scaling, cloneCloningAngleRad, origCloningAngleRad};
                this.selObController.cloneObject(
                    {
                        id: cloneValues.id,
                        newPart: cloneValues.part,
                        newTranslation: selObsArray[i].getRelUVFromAbsUV(cloneValues.translation),
                        newRotation: cloneValues.rotation,
                        newRelSize: selObsArray[i].getRelSize(cloneValues.scaling),
                        origCloningAngleRad: cloneValues.origCloningAngleRad,
                        cloneCloningAngleRad: cloneValues.cloneCloningAngleRad
                    }
                );
            }
        }
    }

    private clearSelection() {

        if (this.selectedObject !== null) {
            this.checkPortalLinesForCloneDeletion(this.selectedObject);
            for (let i = 0, lenI = this.entangledObjects.length; i < lenI; i++) {
                this.checkPortalLinesForCloneDeletion(this.entangledObjects[i]);
            }

            this.selectedObject.handles.hide();
            this.utilityPainter.clearAllLayers();
            if (OwayoJSKonfiViewer.isEmptyTextObject(this.selectedObject)) {
                // FIXME QUICKFIX! Das prüfen wir an zwei Stellen, evtl. wurde das Objekt bereits gelöscht und ist nur über die Referenz "this.selectedObject" erreichbar.
                if (this.getPartSelObById(this.selectedObject.id) !== null) {
                    this.selObController.deleteSelOb(this.selectedObject.id);
                }
            }
            this.selectedObject = null;
        }
        this.deselectEntangledObjects();
        this.render();
    }

    private deselectEntangledObjects() {
        for (let i = 0, lenI = this.entangledObjects.length; i < lenI; i++) {
            this.entangledObjects[i].handles.hide();
        }
        this.entangledObjects = [];
    }


    /**
     * Die Werte des Snaps eines Objects werden mittles PortalLinien geklont
     * @param {string}              origPartName    Name des Parts, auf dem der ursprgl. Snap liegt
     * @param {object}              values          Werte für die Snaps des Objekts
     * @property {object[]}         points          Punkte, die die Snaplinien definieren (x,y)
     * @property {string}           edge            Kante, die auf diese Linie snappt
     * @param {string}              id              id des snappenden Objekts
     */
    public cloneObjectToObjectSnaps(origPartName, values, id) {
        this.portalLines.forEach(line=>{
            if (line.presentOnPart(origPartName)) {
                this.registerObjectToObjectSnapsFromClonedSnapLines(line.cloneSnapLines(origPartName, values, id));
            }
        });
    }

    private registerObjectToObjectSnapsFromClonedSnapLines(result) {
        const lenJ = result.length;
        for (let j = 0; j < lenJ; j++) {
            this.utilityPainter.registerObjectToObjectSnaps(result[j].partName, result[j].pointEdgePair, result[j].id);
        }
    }

    /**
     * Snaps, die durch Portallinien geklont wurden werden entfernt, bzw. deren snappedBsy Einträge mit origId
     * @param {string}  origPartName        Name des Parts, auf dem das Originalobjekt liegt
     * @param {string}  origId              ID des Objekts, dessen Snapwerte geklont worden waren
     */
    public removeClonedSnaps(origPartName, origId) {
        for (let i=0, len = this.portalLines.length; i < len; i++) {
            if (this.portalLines[i].presentOnPart(origPartName)) {
                this.utilityPainter.removeSnaps(origId);
            }
        }
    }

    private setAllPartShadersToShaderIndex(shaderIndex:number)
    {
        let part, obj;

        for (part in this._modelParts ) {

            obj = this._modelParts[part];
            if (shaderIndex < obj.shaders.length && obj.visible) {
                if (obj.mesh.material !== obj.shaders[shaderIndex]) {
                    obj.mesh.material = obj.shaders[shaderIndex];
                }
                obj.mesh.visible = true;
            }
            else {
                obj.mesh.visible = false;
            }

        }
    }

    private getMaxShaders() {
        let part, maxShaders = 1;
        for (part in this._modelParts) {
            maxShaders = Math.max(maxShaders, this._modelParts[part].shaders.length);
        }
        return maxShaders;
    }

    /** This function is called from the RenderAnimationRequest.
     * And should not be called directly.
     * Call "this.render()" instead.*/
    doRender()
    {
        const $this = this;

        return (function(){
            if ($this.container.style.visibility === "hidden") {
                return;
            }
            // if(VIEWERFEATURE.RENDER_STEREO.isOn && typeof($this.effect) !== "undefined") {
            //     $this.effect.render($this.scene, $this.camera);
            //     return;
            // }

            $this.renderer.autoClear = false;

            const maxShaders = $this.getMaxShaders();
            $this.renderer.render($this.scene, $this.camera,undefined,true);
            for (let i = 1; i < maxShaders; i++){
                $this.setAllPartShadersToShaderIndex(i);
                $this.renderer.render($this.scene, $this.camera,undefined,false);
            }

            $this.setModelPartMeshesToNotVisible();
            $this.utilityPainter.setNonEmptyLayersVisibleAndToHandleShader();
            $this.renderer.render($this.scene, $this.camera,undefined,false);
            $this.setAllPartShadersToShaderIndex(0);
        }());
    }

    private setModelPartMeshesToNotVisible() {
        this.withModelPartsDo((part:OwayoKonfiPart)=>(part.mesh as THREE.Mesh).visible = false);
    }

    private withModelPartsDo(callback:(owayoPart:OwayoKonfiPart)=>void) {

        for (const part in this._modelParts ) {
            callback(this._modelParts[part]);
        }
    }

    /**
     * Der Renderer wird z.B. nach einem Context Loss neu initialisiert
     */
    recreateRenderer() {

        let partName, part, oldImage;

        this.clearModelObjects();
        this.clearScene();
        if (this.renderer) {
            this.renderer.domElement = null;
        }

        try {
            this.renderer = new THREE.WebGLRenderer( CONSTANTS.RENDER_PARAMS );
            this.renderer.setPixelRatio( CONSTANTS.DEVICE_PIXEL_RATIO);
        } catch (e) {
            if (!DEBUG){
                WebGLErrorHandler.handleWebGLError(this.controller.getLanguageIso(), WEBGL_ERROR_REASONS[WebGLErrorHandler.webGLFailReason()]);
            }
            return;
        }


        this.renderer.setSize( this.dimensions.viewer.width, this.dimensions.viewer.height );
        this.recreateHandleTexture();

        // add renderer
        this.container.appendChild( this.renderer.domElement );


        this.recreateModelParts();

        this.insertLights();
        this.appendLostContextEvents();

        this.render();

        for (partName in this._modelParts) {
            this.utilityPainter.resetFading();
            part = this._modelParts[partName];

            oldImage = part.helperLayer.texture.image;
            part.helperLayer.texture.dispose();
            part.helperLayer.texture = new THREE.Texture(oldImage);
            part.helperLayer.texture.needsUpdate = true;

            part.handleShader.dispose();
            part.handleShader = HandleShaderCreator.createHandleShader(part);
            OwayoJSKonfiViewer.renewSelectableObjectTextures(part.selectableObjects);

            ShaderCreator.createShaders(part, this.getPatterns(partName));

        }
    }

    private static renewSelectableObjectTextures(selectableObjects) {
        let i, obj, oldImage;
        const len = selectableObjects.length;
        for (i = 0; i < len; i++) {
            obj = selectableObjects[i];

            oldImage = obj.texture.image;
            obj.texture.dispose();
            obj.texture = new THREE.Texture(oldImage);
            obj.texture.needsUpdate = true;
        }
    }


    private getRelSizeOfSelectedObjectOnNewPart(part) {
        const partSizeCM = (this.selectedObject as PartSelectableObject).getParent().partSizeCM;
        const relSize = (this.selectedObject as PartSelectableObject).relSize;
        const absoluteSizeOnOldPart = {
            x: partSizeCM.x * relSize.x,
            y: partSizeCM.y * relSize.y
        };
        return {x: absoluteSizeOnOldPart.x / part.partSizeCM.x, y: absoluteSizeOnOldPart.y / part.partSizeCM.y};
    }

    public partIsDropTarget(part:OwayoKonfiPart) {
        return this.getDroppablePartNames().some(name=>name.replace(/ /g, "")===part.name);
    }

    private tryMovingSelObToNewPart(mouseOnCanvasInfo) {

        const part = this._modelParts[mouseOnCanvasInfo.part];
        if (!this.partIsDropTarget(part)) {
            return;
        }

        // Merke dir die wichtigen alten variablen.
        const translationOffset = (this.selectedObject as PartSelectableObject).interactionStart.translationOffset;
        const offset = new Vector2(translationOffset.x, translationOffset.y);

        const newRelSize = this.getRelSizeOfSelectedObjectOnNewPart(part);
        const positionOnNewPart = {
            x: mouseOnCanvasInfo.position.x / part.textureSize.x,
            y: mouseOnCanvasInfo.position.y / part.textureSize.y
        };
        // Wenn ja so verschieben wir das SelOb auf das neue Part
        this.selObController.moveSelObToPart((this.selectedObject as PartSelectableObject).id, part.name, positionOnNewPart, newRelSize);

        // starte wieder die interaction
        this.startObjectInteraction(VIEWER_INTERACTIONMODES.OBJECT_MOVE, mouseOnCanvasInfo.position);
        (this.selectedObject as PartSelectableObject).interactionStart.translationOffset = offset;
    }

    /**
     * Ein Objekt befindet sich im Translationsmodus. Berechne den Unterschied zwischen Start- und aktueller Position
     */
    private calcObjectTranslation():void {
        const selectedObject = this.selectedObject as PartSelectableObject;
        const mouseOnCanvasInfo   = this.getObjectDataFromMousePosition();

        if (mouseOnCanvasInfo.part === null) {
            return;
        }

        const nearestClone = this.nearestCloneToMousePositionOnPart(
            selectedObject,
            mouseOnCanvasInfo.part,
            mouseOnCanvasInfo.position
        );

        if (nearestClone === selectedObject) {
            this.calcObjectTranslationCarryOn(mouseOnCanvasInfo);
            return;
        }

        if (nearestClone !== null)  {
            EventVerteiler.broadcast(SELOBEVENTNAMES.SELECTION_REQUEST, nearestClone.id);

            nearestClone.interactionStart.translationOffset = new Vector2(
                nearestClone.translation.x - mouseOnCanvasInfo.position.x,
                nearestClone.translation.y - mouseOnCanvasInfo.position.y
            );

            this.calcObjectTranslationCarryOn(mouseOnCanvasInfo);
            return;
        }

        for (let i = 0, lenI = this.portalLines.length; i < lenI; i++) {
            //Wir wissen jetzt, dass es noch keinen Klon gibt.
            //Möglichkeit 1 : ein neuer muss erstellt werden
            //Möglichkeit 2: wir verschieben das Objekt auf einen neuen Part
            const portalLine = this.portalLines[i];

            if (portalLine.presentOnPart(mouseOnCanvasInfo.part) &&
                portalLine.presentOnPart(selectedObject.getParentPartName())) {
                selectedObject.clonedByPortalLineNumber.push(i);
                const cloneValues = portalLine.calculateCloneValues(selectedObject);
                if (cloneValues === null) { //Objekt wurde so schnell über die Portallinie geschoben, dass sie im Moment nicht geschnitten wird...
                    continue;
                }
                this.selObController.cloneObject(
                    {
                        id: cloneValues.id,
                        newPart: cloneValues.part,
                        newTranslation: selectedObject.getRelUVFromAbsUV(cloneValues.translation),
                        newRotation: cloneValues.rotation,
                        newRelSize: selectedObject.getRelSize(cloneValues.scaling),
                        origCloningAngleRad: cloneValues.origCloningAngleRad,
                        cloneCloningAngleRad: cloneValues.cloneCloningAngleRad
                    }
                );

                EventVerteiler.broadcast(SELOBEVENTNAMES.SELECTION_REQUEST, cloneValues.id);
                selectedObject.interactionStart.translationOffset = new Vector2(
                    selectedObject.translation.x - mouseOnCanvasInfo.position.x,
                    selectedObject.translation.y - mouseOnCanvasInfo.position.y
                );

                this.calcObjectTranslationCarryOn(mouseOnCanvasInfo);
                return;
            }

        } // Ende for portalLines

        this.tryMovingSelObToNewPart(mouseOnCanvasInfo);

    }

    private calcObjectTranslationCarryOn(mouseOnCanvasInfo) {
        const part = this._modelParts[mouseOnCanvasInfo.part];

        const translationOffset = (this.selectedObject as PartSelectableObject).interactionStart.translationOffset;
        const endX = mouseOnCanvasInfo.position.x + translationOffset.x;
        const endY = mouseOnCanvasInfo.position.y + translationOffset.y;

        const snappedTranslation = (this.selectedObject as PartSelectableObject).calculateSnap(new Vector2(endX, endY));

        this.selObController.changeSelOb(
            (this.selectedObject as PartSelectableObject).id,
            {
                translation: {
                    x:snappedTranslation.x / part.textureSize.x,
                    y:snappedTranslation.y / part.textureSize.y
                }
            }
        );
    }

    /**
     * Ein Objekt befindet sich im Rotationsmodus. Berechne den Winkel zwischen Mittelpunkt des Objects, Startpunkt der Interaktion
     * und aktueller Mausposition
     */
    private calcObjectRotation() {

        const partSelOb = (this.selectedObject as PartSelectableObject),
            mouseOnCanvasInfo   = this.getObjectDataFromMousePosition(),
            mouseInContainer = this.mouseController.getMouseInContainer(this.getContainerOffset()),
            nearestClone = this.nearestCloneToMousePositionOnPart((this.selectedObject as PartSelectableObject), mouseOnCanvasInfo.part, mouseOnCanvasInfo.position);
        let angle;


        //wenn die Maus ausserhalb des Parts des selektierten Objekts ist...
        if (nearestClone !== (this.selectedObject as PartSelectableObject)) {
            if (mouseOnCanvasInfo.part !== null) {
                // Teste Ob wir auf einem ClonePart sind.
                for (let i=0, len = (this.selectedObject as PartSelectableObject).cloneIds.length; i < len; i+=1) {
                    if ((this.getPartSelObById((this.selectedObject as PartSelectableObject).cloneIds[i]) as PartSelectableObject).getParentPartName() === mouseOnCanvasInfo.part)
                    {
                        EventVerteiler.broadcast(SELOBEVENTNAMES.SELECTION_REQUEST, (this.selectedObject as PartSelectableObject).cloneIds[i]);
                        this.startObjectInteraction(VIEWER_INTERACTIONMODES.OBJECT_ROTATE, mouseOnCanvasInfo.position);
                        return;
                    }
                }
            }


            // Wir sind auf keine Clon nicht auf dem Original. Also berechnen wir es "OffPart"
            angle = -360 / 2 / Math.PI *
                MathUtils.find_angleBogenmass(
                    partSelOb.interactionStart.renderCanvasPosition,
                    partSelOb.interactionStart.selObCenterOnScreen,
                    mouseInContainer
                );


        } else {
            // incl.Umrechnung von Bogen- in Gradmaß
            angle = 360 / 2 / Math.PI *
                MathUtils.find_angleBogenmass(partSelOb.interactionStart.position, partSelOb.translation, mouseOnCanvasInfo.position);
        }

        angle = Math.round(angle + partSelOb.interactionStart.rotation) % 360;
        this.selObController.changeSelOb(partSelOb.id, {rotation: angle});
    }

    /**
     * Ein SelectableObject wurde über den Scaling Handle verändert.
     * Wir berechnen das Verhältnis zwischen Distanz Mittelpunkt-Handle zu Beginn des Vorgangs und der aktuellen Distanz.
     * dieses Verhältnis (neu / alt) wird mit dem scaling Faktor des Objekts verrechnet
     */
    private calcObjectScaling() {

        const mouseOnCanvasInfo   = this.getObjectDataFromMousePosition(),
            mouseInContainer = this.mouseController.getMouseInContainer(this.getContainerOffset()),
            partSelOb           = (this.selectedObject as PartSelectableObject),
            nearestClone = this.nearestCloneToMousePositionOnPart((this.selectedObject as PartSelectableObject), mouseOnCanvasInfo.part, mouseOnCanvasInfo.position);


        const newScale = new Vector2();
        // Wir sind jetzt entweder auf dem gleichen Part oder müssen uns aus den Handels etwas berechnen
        // Das hier könnte man zwar mit in die andere IF-Schleife packen, dann könnte man es aber nicht mehr sogut
        // lesen.
        if  (nearestClone === this.selectedObject) {
            // Wir sind ganz nochrmal auf unserem Part
            const oldDist = MathUtils.vectorLength2D((this.selectedObject as PartSelectableObject).interactionStart.position, (this.selectedObject as PartSelectableObject).translation);
            const newDist = MathUtils.vectorLength2D(mouseOnCanvasInfo.position, (this.selectedObject as PartSelectableObject).translation);

            newScale.x = (this.selectedObject as PartSelectableObject).interactionStart.scaling.x * (newDist / oldDist);
            newScale.y = (this.selectedObject as PartSelectableObject).interactionStart.scaling.y * (newDist / oldDist);

            // Infos die wir nur brauchen wenn wir das Part verlassen.
            (this.selectedObject as PartSelectableObject).interactionStart.lastRenderCanvasPositionOfMouseOverPart = mouseInContainer;
            (this.selectedObject as PartSelectableObject).interactionStart.lastScalingOfMouseOverPart = newScale;
        }
        else
        {
            if (nearestClone !== null) {
                EventVerteiler.broadcast(SELOBEVENTNAMES.SELECTION_REQUEST, nearestClone.id);
                this.startObjectInteraction(VIEWER_INTERACTIONMODES.OBJECT_SCALING, mouseOnCanvasInfo.position);
                return;
            }
            // Wir sind nicht auf dem Part und nicht auf dem Clon.
            // Wir sind neben dem aktuellen Part
            const oldDist = MathUtils.vectorLength2D(
                (this.selectedObject as PartSelectableObject).interactionStart.selObCenterOnScreen,
                (this.selectedObject as PartSelectableObject).interactionStart.lastRenderCanvasPositionOfMouseOverPart
            );
            const newDist = MathUtils.vectorLength2D(
                (this.selectedObject as PartSelectableObject).interactionStart.selObCenterOnScreen,
                mouseInContainer
            );
                newScale.x = (this.selectedObject as PartSelectableObject).interactionStart.lastScalingOfMouseOverPart.x * (newDist / oldDist);
                newScale.y = (this.selectedObject as PartSelectableObject).interactionStart.lastScalingOfMouseOverPart.y * (newDist / oldDist);
        }

        if (newScale.x < CONSTANTS.MIN_SCALING || newScale.y < CONSTANTS.MIN_SCALING) {
            return;
        }

        const relSize = partSelOb.getRelSize(newScale);
        this.selObController.changeSelOb((this.selectedObject as PartSelectableObject).id,{relSize: relSize});
        this.selObController.displaySizeHint((this.selectedObject as PartSelectableObject).id, partSelOb.getSizeInCm(newScale));
        this.selObController.setBerechnungsFeatureForTackleTwill(this.selectedObject.id);
        this.selObController.setDPI(this.selectedObject.id);
    }

    public getPartSelObSizeInCM(selObID) {
        const partSelOb= this.getPartSelObById(selObID);
        if(partSelOb === null) {
            return new Vector2(0,0);
        }
        return partSelOb.getSizeInCm();
    }

    /**
     * Ein SelectableObject wurde gelöscht. Wenns auf einem part liegt, aus dem Shader löschen!
     * @param {string}  id      UUID des selectable Objects
     */
    private deleteSelOb(id) {
        const partSelOb = this.getPartSelObById(id);
        if (partSelOb === null) { //könnte null sein, wenn noch nicht eingefügt
            return;
        }
        if (partSelOb.cloneIds.length > 0) {
            EventVerteiler.handleError("internal", "deleteSelOb", "clone present!!");
        }
        const part = partSelOb.getParent();
        const index = arrayIndexByKeyValue(part.selectableObjects, "id", id);
        part.selectableObjects.splice(index,1);

        this.zOrderTable.deleteEntry(id);

        this.utilityPainter.removeSnaps(id);
        this.utilityPainter.clearActiveSnaps();

        this.removeClonedSnaps(part.name, id);
        if (typeof(partSelOb.handles) !== "undefined") {
            partSelOb.handles.hide();
        }
        this.utilityPainter.repaint();
        ShaderCreator.createShaders(part, this.getPatterns(part.name));
        this.render();
    }

    private static arrayIsSubsetOf(smallArray, toTestAgainst) {
        if (!(Array.isArray(smallArray) && Array.isArray(toTestAgainst) )) {
            return false;
        }
        for (let i = 0, lenI = smallArray.length; i < lenI; i++) {
            if (toTestAgainst.indexOf(smallArray[i]) === -1) {
                return false;
            }
        }
        return true;
    }

    /**
     * wird aufgerufen vom Eventhandler, wenn ein Selectable Object sich geändert hat
     *
     * @param {Logo|TextObject|ChromoLogo} selOb               selectable Object aus dem Controller, das sich geändert hat.
     * @param {String[]}        changedProperties   Die Eigenschaften, die sich geändert haben
     * @param {boolean}            [isClone = false]   Falls das veränderte Objekt ein Klon ist, wird es nicht selektiert
     */
    private selObChanged(selOb, changedProperties, isClone = false) {
        const index = arrayIndexByKeyValue(this._modelParts[selOb.partName].selectableObjects, "id", selOb.id);
        const partSelOb       = this._modelParts[selOb.partName].selectableObjects[index];

        if (index === -1 || !partSelOb.shader) {
            return;
        }


        const shouldExecuteReinit = typeof (changedProperties) !== "undefined" &&
            !OwayoJSKonfiViewer.arrayIsSubsetOf(changedProperties, CONSTANTS.NO_RELOAD_NECESSARY) &&
            typeof ((partSelOb as PartSelectableObjectText|PartSelectableObjectChromoLogo).reInitialize) === "function";


        if (shouldExecuteReinit) {
            (partSelOb as PartSelectableObjectText|PartSelectableObjectChromoLogo).reInitialize(selOb);
        } else {
            partSelOb.copyFromSelOb(selOb);
        }
        partSelOb.updateCalculatedValues();


        this.utilityPainter.changeSnapsForSelOb(partSelOb);
        OwayoJSKonfiViewer.setUniformsOfPartSelOb(partSelOb);

        if (!isClone) {
            this.checkPortalLinesForCloneCreation(partSelOb);
        }
        if (this.selectedObject === null) {
            return;
        }
        partSelOb.placeAppropriateHandles();

        if (!isClone) {
            this.setConflicts(partSelOb);
        }
        this.doSnapRepaint();
    }

    private doSnapRepaint() {
        this.utilityPainter.setActiveSnaps();
        this.utilityPainter.repaint();
        this.utilityPainter.restartFading();
        this.render();
    }

    private static setUniformsOfPartSelOb(partSelOb:PartSelectableObject) {
        const indexInShader = partSelOb.indexInShader;
        const uniforms = (partSelOb.shader as THREE.Shader).uniforms;

        uniforms.selObMatrices.value[indexInShader] = partSelOb.getMatrixAbsCanvasFromAbsUV();
        uniforms.selObRepeat.value[indexInShader] = partSelOb.repeat;
        uniforms.selObClampToColor.value[indexInShader] = partSelOb.clampToColor;
        // uniforms.selObWasserzeichen.value[indexInShader] = partSelOb.wasserzeichen;
        // uniforms.selObWasserzeichenInvertImage.value[indexInShader] = partSelOb.wasserzeichenInvertImage;
        // uniforms.selObWasserzeichenIntensity.value[indexInShader] = partSelOb.wasserzeichenIntensity;
    }

    private setConflicts(partSelOb:PartSelectableObject) {
        if(this.selectedObject === null) {
            return;
        }
        if (OwayoJSKonfiViewer.isInSperrbezirk(partSelOb)) {
            (this.selectedObject as PartSelectableObject).enterConflictedState("isInSperrbezirk");
            EventVerteiler.broadcast("selObInSperrbezirkEvent", {ids: [partSelOb.id]});
            return;
        }
        if ((this.selectedObject as PartSelectableObject).conflicts.isInSperrbezirk === true) {
            (this.selectedObject as PartSelectableObject).leaveConflictedState("isInSperrbezirk");
            EventVerteiler.broadcast(HINTBOXEVENTNAMES.SELOBLEAVINGSPERRBEZIRK, partSelOb.id);
        }
    }

    private static isInSperrbezirk(partSelOb:PartSelectableObject) {
        let sperrbezirk, i, lenI;
        const part = partSelOb.getParent();
        const relTranslation = partSelOb.getRelativeTranslation(part.textureSize);
        const sperrBezirke = part.sperrBezirke;
        for (i = 0, lenI = sperrBezirke.length; i < lenI; i++) {
            sperrbezirk = sperrBezirke[i];
            if (relTranslation[sperrbezirk.dim] > sperrbezirk.from && relTranslation[sperrbezirk.dim] < sperrbezirk.to) {
                return true;
            }
        }
        return false;
    }

    /**
     * überprüft Klone anhand von Portallinien. Wenn das Objekt schneidet aber kein Klon vorhanden ist, wird einer erstellt. Wenn ein Klon da ist, aber nicht schneidet,
     * wird er gelöscht
     *
     * Vorsicht: u.U Kann es passieren, dass nicht der Klon, sondern "das Original" gelöscht werden soll. Dass ist dann der fall, wenn wir über z.B. scaling über eine
     * Portallinie das Original so verändern, dass es komplett vom sichtbaren Part verschwunden ist.
     * D.h. das löschen checken wir erst, wenn wir ein mouseUp haben...
     */
    private checkPortalLinesForCloneCreation(partSelOb) {

        let i, lenI, indexOfPortalLine, intersects, cloneValues;

        if (partSelOb.cloneIds.length === 0 && partSelOb.clonedByPortalLineNumber.length !== 0) {
            logIfDebug("ClonedByPortalLineNumber passt nicht mit cloneIds zusammen");
            partSelOb.clonedByPortalLineNumber = [];
        }

        for (i = 0, lenI = this.portalLines.length; i < lenI; i++) {
            indexOfPortalLine = partSelOb.clonedByPortalLineNumber.indexOf(i);
            intersects = this.portalLines[i].intersectsObject(partSelOb);

            if (intersects !== false && indexOfPortalLine === -1){ // die Portallinie schneidet, ist aber noch nicht als klonend eingetragen
                partSelOb.clonedByPortalLineNumber.push(i);
                cloneValues = this.portalLines[i].calculateCloneValues(partSelOb);

                this.selObController.cloneObject(
                    {
                        id: cloneValues.id,
                        newPart: cloneValues.part,
                        newTranslation: partSelOb.getRelUVFromAbsUV(cloneValues.translation),
                        newRotation: cloneValues.rotation,
                        newRelSize: partSelOb.getRelSize(cloneValues.scaling),
                        origCloningAngleRad: cloneValues.origCloningAngleRad,
                        cloneCloningAngleRad: cloneValues.cloneCloningAngleRad
                    }
                );
            }
        }

    }

    private static createEmptyPartSelObType(type:string) {
        switch (type) {
            case  SelObTypes.TEXT:
                return Object.create(PartSelectableObjectText.prototype);
            case SelObTypes.LOGO:
                return Object.create(PartSelectableObjectLogo.prototype);
            case SelObTypes.CHROMOLOGO:
            case SelObTypes.STOCKLOGO:
            default:
                return Object.create(PartSelectableObjectChromoLogo.prototype);

        }
    }

    /**
     * Es wird geprüft, ob ein Objekt inzwischen eine Snaplinie nicht mehr schneidet und deswegen ein Klon gelöscht werden soll
     * @param {PartSelectableObject}    partSelOb
     */
    private checkPortalLinesForCloneDeletion(partSelOb) {

        let i, indexOfPortalLineInClonedByArray;
        const lenI = this.portalLines.length;
        for (i = 0; i < lenI; i++) {
            indexOfPortalLineInClonedByArray = partSelOb.clonedByPortalLineNumber.indexOf(i);
            const portalLine = this.portalLines[i];
            if(portalLine.intersectsObject(partSelOb) === true || indexOfPortalLineInClonedByArray === -1) {
                continue;
            }
            this.removeClonesAfterPortallineDoesNotIntersectAnymore(partSelOb, portalLine, indexOfPortalLineInClonedByArray);
        }
    }

    private removeClonesAfterPortallineDoesNotIntersectAnymore(partSelOb: PartSelectableObject, portalLine: PortalLine, indexOfPortalLineInClonedByArray) {

        if (partSelOb.isOutOfBounds()) {
            const clone = partSelOb.cloneOnPart(portalLine.getComplimentaryPart(partSelOb.getParentPartName()));
            if (clone !== null) {
                clone.clonedByPortalLineNumber.splice(indexOfPortalLineInClonedByArray, 1);
                if (partSelOb === this.selectedObject) {
                    EventVerteiler.broadcast(SELOBEVENTNAMES.SELECTION_REQUEST, clone.id);
                }
                this.selObController.deleteClone(clone.id, partSelOb.id);
            }
            return;
        }
        partSelOb.clonedByPortalLineNumber.splice(indexOfPortalLineInClonedByArray, 1);
        const otherPart = portalLine.getComplimentaryPart(partSelOb.getParentPartName());
        for (let i = partSelOb.cloneIds.length - 1; i > -1; i--) {
            const clone = this.getPartSelObById(partSelOb.cloneIds[i]) as PartSelectableObject;
            if (clone.getParentPartName() === otherPart) {
                this.selObController.deleteClone(partSelOb.id, clone.id);
            }
        }
    }

    /**
     * Vom Controller kam die Nachricht, das ein Objekt ausgewählt werden soll. Ein evtl. bereits ausgewähltes Objekt
     * wird deselektiert
     * @param {TextObject|Logo} selOb
     *
     */
    private selObFromControllerSelected(selOb:SelectableObject): void {
        const part = this._modelParts[selOb.partName];
        const partSelOb = arrayElementByKeyValue(part.selectableObjects, "id", selOb.id);
        if(partSelOb !== null) {
            this.partSelObSelected(partSelOb);
        }
    }

    static isEmptyTextObject(partSelOb:PartSelectableObject) {
        return partSelOb.type === SelObTypes.TEXT &&(partSelOb as PartSelectableObjectText).isEmpty();
    }

    private deSelectPartSelObAndReturnpartsWithNewShaders() {
        const createShadersFor:OwayoKonfiPart[] = [];
        const addToCreateShadersForIfNotAlreadyExists = (part:OwayoKonfiPart)=>{
            if (createShadersFor.indexOf(part) === -1) {
                createShadersFor.push(part);
            }
        }

        (this.selectedObject as PartSelectableObject).handles.hide();
        this.utilityPainter.clearAllLayers();

        createShadersFor.push((this.selectedObject as PartSelectableObject).getParent());

        this.entangledObjects.forEach(function(partSelOb){
            const part = partSelOb.getParent();
            partSelOb.handles.hide();
            addToCreateShadersForIfNotAlreadyExists(part);
        });
        if (OwayoJSKonfiViewer.isEmptyTextObject(this.selectedObject as PartSelectableObject)) {
            this.selObController.deleteSelOb((this.selectedObject as PartSelectableObject).id);
        }
        this.selectedObject = null;
        this.entangledObjects = [];
        return createShadersFor;
    }

    private partSelObSelected(partSelOb:PartSelectableObject) {
       const createShadersFor:OwayoKonfiPart[] = [];
        const $this = this;

        const addToCreateShadersForIfNotAlreadyExists = (part:OwayoKonfiPart)=>{
            if (createShadersFor.indexOf(part) === -1) {
                createShadersFor.push(part);
            }
        }

        if (this.selectedObject !== null) {
            createShadersFor.concat(this.deSelectPartSelObAndReturnpartsWithNewShaders());
        }
        this.selectedObject = partSelOb;
        this.selectedObject.placeAppropriateHandles();
        this.selectedObject.cloneIds.forEach(function(id) {
            const clone = $this.getPartSelObById(id) as PartSelectableObject;
            $this.entangledObjects.push(clone);
            clone.placeAppropriateHandles();
            addToCreateShadersForIfNotAlreadyExists(clone.getParent());
        });
        this.utilityPainter.resetFading();
        this.utilityPainter.setActiveSnaps();
        this.utilityPainter.repaint();
        addToCreateShadersForIfNotAlreadyExists(partSelOb.getParent());
        this.render();
    }

    private createEmpty2DimensionalArrayForParts() {
        const sortedArray :(SelectableObject[])[] = [];
        for (const part in this._modelParts) {
            sortedArray[part] = [];
        }
        return sortedArray;
    }

    private sortSelObsIntoPartsArray(selObArray) {
        const sortedArray = this.createEmpty2DimensionalArrayForParts();

        for (let i =0; i < selObArray.length; i +=1) {
            if(typeof(sortedArray[selObArray[i].partName]) === "undefined") {
                this.tryToChangePartnameToActuallyExistingPart(selObArray[i]);

            }
            if(typeof(sortedArray[selObArray[i].partName]) === "undefined") {
                console.log("skipping selob "+selObArray[i].id+" because "+selObArray[i].partName+" was not found");
                continue;
            }
            sortedArray[selObArray[i].partName].push(selObArray[i]);
        }
        return sortedArray;

    }

    private tryToChangePartnameToActuallyExistingPart(selOb: SelectableObject) {
        const newPartName = this.searchForSimilarPartnameLikeCapitalizationDifferences(selOb.partName);
        if (newPartName !== selOb.partName) {
            selOb.partName = newPartName;
            this.selObController.selObPartnameWasChangedDueToCapitalizationErrors(selOb);
        }
    }

    private searchForSimilarPartnameLikeCapitalizationDifferences(selObPartName) {
        let modelPartname;
        for (modelPartname in this._modelParts) {
            if (modelPartname.toLowerCase() === selObPartName.toLowerCase()) {
                return modelPartname;
            }
        }
    }

    private abortInsertingObjectToPart(id, part) {
        logIfDebug("skipping object "+id);
        this._modelParts[part].pendingTasks.taskFinished();
        this.viewerTasks.taskFinished();
    }

    /**
     * Lädt selectableObjects in das Model
     * @param {Array.<Logo|TextObject|ChromoLogo>}     objects         die Selectable Objects aus dem Controller
     * @param {Array[]}    zOrder          eine Tabelle wie sie @see Z_OrderTable verwendet
     */
    private loadSelectableObjectArray(objects, zOrder) {

        let part;
        if (objects.length === 0) {
            return;
        }
        const sortedArray = this.sortSelObsIntoPartsArray(objects);

        for (part in sortedArray) {
            if (sortedArray[part].length > 0) {
                this.insertSelObsInPart(part, sortedArray[part], zOrder);
            }
        }
    }

    private insertSelObsInPart(part, selObsOnPart, zOrder) {
        this._modelParts[part].pendingTasks.addTasks(selObsOnPart.length);
        for (let i = 0; i < selObsOnPart.length; i += 1) {
            this.insertSelObOnPart(part, selObsOnPart[i], zOrder);
        }
    }

    private insertSelObOnPart(part, selOb, zOrder) {
        let zIndex;
        if (arrayIndexByKeyValue(this._modelParts[part].selectableObjects, "id", selOb.id) > -1) {
            this.abortInsertingObjectToPart(selOb.id, part);
            return;
        }

        for (let j = 0, lenJ = zOrder.length; j < lenJ; j++) {
            if (arrayIndexByKeyValue(zOrder[j], "id", selOb.id) > -1) {
                zIndex = j;
                break;
            }
        }
        this.insertSelOb(selOb, zIndex);
    }

    getPartSelObById(id):PartSelectableObject|null {

        let partName, element;

        for (partName in this._modelParts) {
            element =  arrayElementByKeyValue(this._modelParts[partName].selectableObjects, "id", id);
            if (element !== null) {
                return element;
            }
        }
        return null;
    }

    public getHeightInCMFromHeightInPixelRespectingScaling(selObID, heightPixel) {
        const partSelOb = this.getPartSelObById(selObID);
        if(partSelOb === null) {
            return 0;
        }

        const part = partSelOb.getParent();
        if(typeof(part) === "undefined") {
            return 0;
        }
        const disregardingScaling = heightPixel * part.partSizeCM.y / part.textureSize.y;
        return disregardingScaling * partSelOb.scaling.y;
    }

    public getSelObScalingY(selObID) {
        const partSelOb = this.getPartSelObById(selObID);
        if(partSelOb === null) {
            return 0;
        }
        return partSelOb.scaling.y;
    }

    public getSelObParentHeightInCM(selObID:string) {
        const partSelOb = this.getPartSelObById(selObID) as PartSelectableObject;
        const part = partSelOb.getParent();
        if(typeof(part) === "undefined") {
            return 0;
        }
        return part.partSizeCM.y;
    }

    public getSelObParentHeightInPixel(selObID:string) {
        const partSelOb = this.getPartSelObById(selObID);
        if(partSelOb === null) {
            return 0;
        }
        const part = partSelOb.getParent();
        if(typeof(part) === "undefined") {
            return 0;
        }
        return part.textureSize.y;
    }

    public getHeightInPixelsFromHeightInCMRespectingScaling(selObId, heightCM) {
        const partSelOb = this.getPartSelObById(selObId);
        if(partSelOb === null) {
            return 0;
        }
        const part = partSelOb.getParent();
        if(typeof(part) === "undefined") {
            return 0;
        }
        const rel = heightCM / part.partSizeCM.y;
        return rel * part.textureSize.y / partSelOb.scaling.y;
    }

    /**
     *  Wenn wir uns gerade über dem Modell befinden, wenn diese Funktion aufgerufen wird, so wird der Controller gebeten, ein Objekt auf
     * diesem Part zu erstellen. Ansonsten wird das Objekt mit der id SelObId gelöscht
     */
    public tryInsertingSelOb(selObId):"success"|"retry"|"failed" {
        const mouseInfo = this.getObjectDataFromMousePosition(),
            $this = this,
            typeOfSelOb = ($this.selObController.getSelOb(selObId) as SelectableObject).type;
            const callbacks:(()=>void)[] = [];
            const relativePosition = new Vector2();
            let colorCode;
        if(mouseInfo.hitModel !== true) {
            this.selObController.deleteSelOb(selObId);
            return 'failed';
        }

        const part = this._modelParts[mouseInfo.part];
        if(!this.partIsDropTarget(part)) {
            callbacks.push(function(){$this.greyOutNotDroppableParts();});
            EventVerteiler.broadcast("displayDialogEvent", {dialog: "partNotDroppable", callbacks:callbacks});
            return 'retry';
        }

        relativePosition.x = mouseInfo.position.x / part.textureSize.x;
        relativePosition.y = mouseInfo.position.y / part.textureSize.y;
        if(typeOfSelOb === SelObTypes.TEXT) {
            colorCode = part.getHitColorCode(mouseInfo.position);
        }
        // wir geben dem Browser die Möglichkeit, die Drag&Drop Animation fertig zu machen
        setTimeout(function(){
            if(typeOfSelOb === SelObTypes.TEXT) {
                $this.selObController.setContrastColorOnTextObjectIfNeededWithoutCallingChangeSelOb(selObId, colorCode);
            }
            $this.selObController.insertSelObById(selObId, part.name, relativePosition.x, relativePosition.y, "byUser");
        },50);
        return 'success';


    }

    /**
     * Fügt ein (bereits erstelltes und bereitgehaltenes) SelectableObject in den Viewer ein.
     * Normaler Ablauf: Viewkomponente: CreateObject =>Controller:ObjectCreatedEvent=> Viewer:InsertObject
     * =>Controller: ObjectInsertedEvent ===>>> this.insertSelObById
     */
    private insertSelOb(selOb, zIndex, mayBeAppendedToEntry = true) {
        const $this = this;

        if (SelObTypes.isEinfaerbbaresLogo(selOb.type) && selOb.currentSVG === "") {
            EventVerteiler.createTask("insertChromoLogo"+selOb.id)
                .when("chromoLogoSVG"+selOb.id, "loaded")
                .thenDo(()=>$this.insertSelOb(selOb, zIndex));
            return;
        }
        const part = this._modelParts[selOb.partName];
        this.zOrderTable.insertEntryIntoZIndex(selOb.id, selOb.floating, zIndex, mayBeAppendedToEntry);

        const newObjectParameters = selOb.clone(true);
        newObjectParameters.parent      = part;
        newObjectParameters.translation = {x: selOb.translation.x * part.textureSize.x, y: selOb.translation.y * part.textureSize.y};

        const newOb = OwayoJSKonfiViewer.getNewpartSelectableObjectFromSelOb(selOb, newObjectParameters);
        if(newOb === null) {
            if(DEBUG){alert("unknown Selob Type");}
            return;
        }

        this._modelParts[selOb.partName].insertPartSelOb(newOb);
        newOb.init().then(()=>{
            globalsObject.resourceManager.registerLoadedResourceWithoutData(selOb.id+"_initialized", "productChange")
            this.setConflicts(newOb);
            this.recreateAllShaders();

        });
    }

    /**
     * Ein Objekt wird geklont und mit den in clonedSelObFromController angegeben Werten angepasst
     * @param {string}                  origId      ID des originalen Objekts
     * @param {SelectableObject|TextObject|Logo}   clonedSelObFromController Das Objekt aus dem Model des Controllers mit den Werten die wir brauchen
     */
    private createClone(origId, clonedSelObFromController) {

        let origIsSelected = false;

        const partSelOb = this.getPartSelObById(origId);
        if (partSelOb === this.selectedObject) {
            origIsSelected = true;
        }
        if (partSelOb === null) {
            EventVerteiler.handleError("internal", "createClone", "Viewer here, could not clone object " + origId);
            return;
        }
        const part  = partSelOb.getParent();
        partSelOb.setParent(null); // wir wollen den Part nicht klonen, der soll ruhig Referenz bleiben
        const clone = deepCopy(true, OwayoJSKonfiViewer.createEmptyPartSelObType(partSelOb.type), partSelOb);
        //($ as JQueryStatic).extend(true, OwayoJSKonfiViewer.createEmptyPartSelObType(partSelOb.type), partSelOb);
        partSelOb.setParent(part);
        partSelOb.translation = new Vector2(partSelOb.translation.x, partSelOb.translation.y);

        this.fillCloneWithValuesFromControllerClonedObject(clone, clonedSelObFromController, partSelOb);
        for (let i = 0; i < partSelOb.cloneIds.length; i++) {
            (this.getPartSelObById(partSelOb.cloneIds[i]) as PartSelectableObject).cloneIds.push(clone.id);
        }
        partSelOb.cloneIds.push(clone.id);

        this.zOrderTable.insertEntryIntoZIndex(clone.id, clone.floating, part.zOrderTable.getZIndex(partSelOb.id));
        this._modelParts[clonedSelObFromController.partName].insertPartSelOb(clone);
        clone.updateCalculatedValues();
        this.utilityPainter.addSnapsForSelOb(clone, true);


        if (origIsSelected) {
            this.entangledObjects.push(clone);
            this.utilityPainter.repaint();
            this.placeHandlesOnSelectedObjectAndClones();
        }

        ShaderCreator.createShaders(this._modelParts[clonedSelObFromController.partName], this.getPatterns(clonedSelObFromController.partName));
    }

    private fillCloneWithValuesFromControllerClonedObject(clone:PartSelectableObject, clonedSelObFromController:SelectableObject, partSelOb: PartSelectableObject) {
        clone.parent = this._modelParts[clonedSelObFromController.partName];
        clone.id = clonedSelObFromController.id;
        clone.translation = clone.getAbsUVFromRelUV(clonedSelObFromController.translation.x, clonedSelObFromController.translation.y);


        clone.relSize = new Vector2(clonedSelObFromController.relSize.x, clonedSelObFromController.relSize.y);
        clone.rotation = clonedSelObFromController.rotation;

        clone.setScalingFromRelSize(clonedSelObFromController.relSize);
        clone.handles = clone.createHandles();

        clone.cloneIds.push(partSelOb.id);
    }

    private deleteClone(idOfOriginal, cloneIdToDelete) {

        let index = arrayIndexByKeyValue(this.entangledObjects, "id", cloneIdToDelete);

        if (index > -1) {
            this.entangledObjects.splice(index,1);
        }
        const clone = this.getPartSelObById(cloneIdToDelete);
        if (clone === null) {
            warnIfDebug("Viewer here, could not find Clone " + cloneIdToDelete);
            return;
        }
        const part    = clone.getParent();

        index   = arrayIndexByKeyValue(part.selectableObjects, "id", cloneIdToDelete);
        clone.handles.hide();
        part.selectableObjects.splice(index,1);
        this.zOrderTable.deleteEntry(clone.id);


        this.utilityPainter.removeSnaps(cloneIdToDelete);
        this.utilityPainter.activeSnaps = [];
        this.removeClonedSnaps(part.name, cloneIdToDelete);
        const orig    = this.getPartSelObById(idOfOriginal) as PartSelectableObject;
        index   = orig.cloneIds.indexOf(cloneIdToDelete);
        if (index > -1) {
            orig.cloneIds.splice(cloneIdToDelete);
        }
        if (orig.cloneIds.length === 0) {
            orig.clonedByPortalLineNumber = [];
            //TODO wenn wir wirklich mal mehrere Portallinien haben, die von einem Objekt geschnitten werden dann ist das hier ein BUG!
        }
        this.utilityPainter.repaint();
        ShaderCreator.createShaders(part, this.getPatterns(part.name));
        this.render();
    }

    private static isObjectManipulationInteractionMode(interactionMode:VIEWER_INTERACTIONMODES) {
        return [
            VIEWER_INTERACTIONMODES.OBJECT_SCALING,
            VIEWER_INTERACTIONMODES.OBJECT_ROTATE,
            VIEWER_INTERACTIONMODES.OBJECT_MOVE
        ].indexOf(interactionMode) >-1;
    }

    private onDocumentMouseUp() {
        if (OwayoJSKonfiViewer.isObjectManipulationInteractionMode(this.interactionMode)) {
            EventVerteiler.broadcast("objectInteractionEndingEvent", (this.selectedObject as PartSelectableObject).id);
            this.checkPortalLinesForCloneDeletion((this.selectedObject as PartSelectableObject));
            this.entangledObjects.forEach(o=>this.checkPortalLinesForCloneDeletion(o));
            if(this.interactionMode === VIEWER_INTERACTIONMODES.OBJECT_SCALING) {
                this.selObController.recalcOutlineIfNecessary((this.selectedObject as PartSelectableObject).id);
            }
        }
        if (this.interactionMode === VIEWER_INTERACTIONMODES.PANNING) {
            this.removePanningClass();
        }
        if(this.interactionMode === VIEWER_INTERACTIONMODES.SELOBDELETE) {
            this.interactionMode = VIEWER_INTERACTIONMODES.NONE
        } else
        if (this.interactionMode !== VIEWER_INTERACTIONMODES.WAIT_FOR_DROP) {
           if(this.mouseController.mouseHasMovedLessThan(100)) {
               this.selectColorIfMouseOverColor();
           }
           this.interactionMode = VIEWER_INTERACTIONMODES.NONE;
        }
        this.zoomController.stopZooming();
        if (this.selectedObject !== null) {
            this.utilityPainter.restartFading();
        }
        this.utilityPainter.liftGreyout();
    }

    private startModelPanning() {
        this.interactionMode = VIEWER_INTERACTIONMODES.PANNING;
        this.mouseController.setCameraPositionOnMouseDown(this.camera.position);
        this.setPanningClass();
    }

    private startModelRotation() {
        this.interactionMode = VIEWER_INTERACTIONMODES.ROTATE;
        this.mouseController.setRotationOnMouseDown(this.getModelRotation());
    }


    private getHandleFromPartAndId = (part, handleId)=>arrayElementByKeyValue(this._modelParts[part].handles, "id", handleId);

    private executeHandlerAction(handler, position) {
        const handleIdActionMap = {
            "deleteHandle": () => {
                this.selObController.deleteSelOb((this.selectedObject as PartSelectableObject).id, true, "byUser");
                this.interactionMode = VIEWER_INTERACTIONMODES.SELOBDELETE;
            },
            "rotateHandle":()=>this.startObjectInteraction(VIEWER_INTERACTIONMODES.OBJECT_ROTATE, position),
            "scalingHandle":()=>this.startObjectInteraction(VIEWER_INTERACTIONMODES.OBJECT_SCALING, position),
            "zOrderDownHandle":()=>this.zOrderOperation("down"),
            "zOrderUpHandle":()=>this.zOrderOperation("up"),
            "pinHandle":()=>this.selObController.changeIsPinned((this.selectedObject as PartSelectableObject).id),
            "doubleHandle":()=>this.selObController.prepareSelObDuplication(
                (this.selectedObject as PartSelectableObject).id, (this.selectedObject as PartSelectableObject).getParent().getCounterpart()
            )
        };

        if(typeof(handleIdActionMap[handler.id]) !== "undefined") {
            handleIdActionMap[handler.id]();
        } else {
            EventVerteiler.handleError("severe", "handleWasHit", "wrong handleName" + handler.id);
        }
    }

    private handleWasHit(part, handleId, position) {

        const handler = this.getHandleFromPartAndId(part, handleId);

        if ((this.selectedObject as PartSelectableObject).id !== handler.handleFor) { // könnte den Handle eines Klons getroffen haben
            EventVerteiler.broadcast(SELOBEVENTNAMES.SELECTION_REQUEST, handler.handleFor);
        }

        if ((this.selectedObject as PartSelectableObject).isPinned && handler.id !== "pinHandle" &&  handler.id !== "doubleHandle" ) {
            // Model Rotation
            this.startModelRotation();
            EventVerteiler.broadcast("displayHintEvent", "konf_Hint_SelObPinned");
            return;
        }
        this.executeHandlerAction(handler, position);
    }

    private selObWasHit(id, position) {

        let partSelOb;
        if (this.selectedObject === null || id !== (this.selectedObject as PartSelectableObject).id) {
            partSelOb = this.getPartSelObById(id);
            if (!partSelOb.allowDrag && !partSelOb.allowResize && !partSelOb.allowDelete) { //das ist wohl ein SponsoringLogo
                if (this.selectedObject !== null) {
                    this.broadCastClearSelection();
                }
                this.startModelRotation();
                return;
            }
            EventVerteiler.broadcast(SELOBEVENTNAMES.SELECTION_REQUEST, id);
            //TODO müsste ich hier nicht this.selectedObject setzen? Wird natürlich vom Eventhandler gemacht, aber evtl später!
        }

        if ((this.selectedObject as PartSelectableObject).isPinned) {
            this.startModelRotation();
            EventVerteiler.broadcast("displayHintEvent", "konf_Hint_SelObPinned");
            return;
        }

        if ((this.selectedObject as PartSelectableObject).allowDrag === true) {
            this.startObjectInteraction(VIEWER_INTERACTIONMODES.OBJECT_MOVE, position);
        }
    }

    public setNewInteractionMode() {

        if (this.selectedObject !== null) {
            this.utilityPainter.resetFading();
        }

        if (this.interactionMode === VIEWER_INTERACTIONMODES.WAIT_FOR_DROP) {
            const status = this.tryInsertingSelOb(this.waitingForDrop);

            if (status !== 'retry') {
                this.waitingForDrop = "";
                this.interactionMode = VIEWER_INTERACTIONMODES.NONE;
            }
            return;
        }

        const result = this.getObjectDataFromMousePosition();

        if (result.part !== null ) {
            this.setNewInteractionModeOnPart(result);
        } else {
            if (this.selectedObject !== null) {
                this.broadCastClearSelection();
            }
        }
        if (this.interactionMode === VIEWER_INTERACTIONMODES.NONE) {
            if (this.mouseController.isCTRLKeyPressed()) {
                this.startModelPanning();
            } else {
                this.startModelRotation();
            }
        }
    }

    private setNewInteractionModeOnPart(result) {
        if (VIEWERFEATURE.EDIT_MATERIALS) {
            this.materialController.openEditor( this._modelParts[result.part].owayoMaterial.stoff );
        }
        const detailedResult = this._modelParts[result.part].getHitObjectAndColor(result.position);

        if (detailedResult.hitHandler !== null) {
            this.handleWasHit(result.part, detailedResult.hitHandler, result.position);
            return;
        }
        if (detailedResult.selectableObjectID !== null) {
            this.selObWasHit(detailedResult.selectableObjectID, result.position);
            return;
        }
    }

    private setPanningClass = ()=>this.container.classList.add("panningHappening");
    private removePanningClass = ()=>this.container.classList.remove("panningHappening");

    private zOrderOperation(direction:"up"|"down") {
        if (this.selectedObject === null) {
            EventVerteiler.handleError("internal", "zOrderOperation", "no selected Object found for zOrder!");
            return;
        }
        const zIndizesAndWarnings = this.selectedObject.overlappingObjectZIndizes();
        const zIndizes = zIndizesAndWarnings.zIndizes;
        const ownZIndex = this.selectedObject.getParent().zOrderTable.getZIndex(this.selectedObject.id);
        const foundIndex = Z_OrderTable.getZIndexToChangeTo(zIndizes, ownZIndex, direction);
        if (foundIndex === -1) {
            EventVerteiler.handleError("internal", "zOrderOperation", "could not complete z Order Operation");
            return;
        }
        this.selObController.changeZOrder(this.selectedObject.id, zIndizes[foundIndex]);
    }

    private startObjectInteraction(interactionMode:VIEWER_INTERACTIONMODES, fromPosition) {

        if (this.selectedObject === null) {
            EventVerteiler.handleError("internal", "startObjectInteraction", "no selected Object found!");
            return;
        }

        this.utilityPainter.greyOutInactiveParts();
        switch (interactionMode) {
            case VIEWER_INTERACTIONMODES.OBJECT_MOVE:
                this.selectedObject.interactionStart.translationOffset = new Vector2(
                    this.selectedObject.translation.x - fromPosition.x,
                this.selectedObject.translation.y - fromPosition.y
                );
                break;
            case VIEWER_INTERACTIONMODES.OBJECT_ROTATE:
                this.selectedObject.interactionStart.rotation = this.selectedObject.rotation;
                break;
            case VIEWER_INTERACTIONMODES.OBJECT_SCALING:
                this.selectedObject.interactionStart.scaling = new Vector2(this.selectedObject.scaling.x, this.selectedObject.scaling.y);
                break;
            default:
                break;
        }

        EventVerteiler.broadcast("objectInteractionStartingEvent", this.selectedObject.id);
        const offset = this.getContainerOffset();
        this.selectedObject.interactionStart.position = fromPosition;
        this.selectedObject.interactionStart.selObCenterOnScreen = this.getSelObCenterOnScreen(this.selectedObject);
        this.selectedObject.interactionStart.lastRenderCanvasPositionOfMouseOverPart = this.mouseController.getMouseInContainer(offset);
        this.selectedObject.interactionStart.renderCanvasPosition = this.mouseController.getMouseInContainer(offset);

        this.interactionMode = interactionMode;
    }

    private getSelObCenterOnScreen(partSelOb:PartSelectableObject) : Vector2 {
        const result = new Vector2(-1, -1);

        const part = partSelOb.getParent();
        const relTranslation = partSelOb.getRelativeTranslation(part.textureSize);
        const object3DCoordinate = getObject3DCoordinateOfUV(part.mesh, relTranslation, true);
        const v = object3DCoordinate.coordinateOnObject.project(this.camera);

        const percX = (v.x + 1) / 2;
        const percY = (-v.y + 1) / 2;

        result.x = percX * this.renderer.domElement.clientWidth;
        result.y = percY * this.renderer.domElement.clientHeight;
        return result;
    }

    public doMouseMove() {
        if (this.interactionMode === VIEWER_INTERACTIONMODES.NONE || this.mouseController.mouseMoveInAction) {
            return;
        }
        this.mouseController.startMouseMoveInAction();
        this.handleMouseMove();
    }

    public handleMouseMove() {
        switch (this.interactionMode) {
            case VIEWER_INTERACTIONMODES.ROTATE:
                this.calcModelRotation();
                break;
            case VIEWER_INTERACTIONMODES.PANNING:
                this.calcModelPanning();
                break;
            case VIEWER_INTERACTIONMODES.OBJECT_MOVE:
                this.calcObjectTranslation();
                break;
            case VIEWER_INTERACTIONMODES.OBJECT_ROTATE:
                this.calcObjectRotation();
                break;
            case VIEWER_INTERACTIONMODES.OBJECT_SCALING :
                this.calcObjectScaling();
                break;
            case VIEWER_INTERACTIONMODES.WAIT_FOR_DROP:
                if (this.hasNotDroppableParts()) {
                    this.changeCursorIfNotDroppable();
                }
                break;
            default:
                break;
        }
    }

    changeCursorIfNotDroppable() {
        this.container.getElementsByTagName("canvas")[0].style.cursor = this.checkIfOverNotDroppablePart() ? "not-allowed" : "";
    }

    public checkIfOverNotDroppablePart() {
        const result = this.getObjectDataFromMousePosition();
        return result.part !== null && this.partIsDropTarget(this._modelParts[result.part]) === false;
    }

    private getObjectDataFromMousePosition():{hitContainer,hitModel,part,position: Vector2WithUV,rawPositionInContainer:Vector2} {
        const result = {
                hitContainer: false,
                hitModel: false,
                part: null,
                position: new Vector2WithUV(),
                rawPositionInContainer: new Vector2()
            };

        result.rawPositionInContainer = this.mouseController.getMouseInContainer(this.getContainerOffset());
        const mouseInContainerAsValueBetweenPlusMinusOne =
            this.mouseController.getMouseInContainerAsValueBetweenPlusMinusOne(this.dimensions.viewer, this.getContainerOffset());

        // Alle werte kleiner -1 oder größer 1 werden abgeschnitten
        //noinspection JSSuspiciousNameCombination
        if (Math.abs(mouseInContainerAsValueBetweenPlusMinusOne.x) >1  || Math.abs(mouseInContainerAsValueBetweenPlusMinusOne.y) > 1) {
            return result;
        }
        result.hitContainer = true;
        return this.getObjectDataFromMousePositionThatHitContainer(result, mouseInContainerAsValueBetweenPlusMinusOne);
    }

    private getIntersects(mouseInContainerAsValueBetweenPlusMinusOne:Vector2) {
        const vector = new THREE.Vector3();
        const raycaster = new THREE.Raycaster();

        // wir erstellen nun aus den Mausdaten einen Vector um daraus einen Intersection Punkt zu berechnen
        vector.set(mouseInContainerAsValueBetweenPlusMinusOne.x, mouseInContainerAsValueBetweenPlusMinusOne.y, 0.5 );
        vector.unproject ( this.camera );
        // erstelle eine raycaster Objeckt um damit die Intersection zu berechnen
        raycaster.ray.origin.copy(this.camera.position);
        raycaster.ray.direction.copy(vector.sub( this.camera.position ).normalize());



        // Berechne die Intersection Points mit allen Onject und Unterobjekten
        // von unserem Array ModelObjects. Die Objecte sind in der Reihenfolge aufgelistet
        // wie der "Strahl" die Objeckte trifft.
        return raycaster.intersectObjects( this.modelObjects, true );
    }


    public getPartAndUVUnderMouse(mouseInContainerAsValueBetweenPlusMinusOne:Vector2, preferredPartname=""):{partname, u, v} {
        const intersects = this.getIntersects(mouseInContainerAsValueBetweenPlusMinusOne).filter(intersect=>intersect.object.visible && intersect.intersectsFrontSide);

        const out= {
            partname:null as string|null,
            u:-1,
            v:-1
        };
        if(preferredPartname !== "") {
            const intersect = intersects.find(intersect=>intersect.object.name === preferredPartname);
            if(intersect !== undefined) {
                out.partname     = intersect.object.name;
                out.u = intersect.uv.x;
                out.v = intersect.uv.y;
                return out;
            }
        }
        for (let i = 0, length = intersects.length; i < length; i +=1)
        {
            const MeshUnderMouse = intersects[i].object;
            if (this._modelParts[MeshUnderMouse.name].hasZentralesAbgelegtesNichtEinfaerbbaresPartImage === false || VIEWERFEATURE.EDIT_MATERIALS) {
                out.partname     = MeshUnderMouse.name;
                out.u = intersects[i].uv.x;
                out.v = intersects[i].uv.y;
                return out;
            }

        }
        return out;
    }

    private getObjectDataFromMousePositionThatHitContainer(result, mouseInContainerAsValueBetweenPlusMinusOne:Vector2) {
        let preferredPart = "";
        if(this.interactionMode === VIEWER_INTERACTIONMODES.OBJECT_ROTATE || this.interactionMode === VIEWER_INTERACTIONMODES.OBJECT_SCALING) {
            preferredPart = this.selectedObject.getParentPartName();
        }

        const partAndUV = this.getPartAndUVUnderMouse(mouseInContainerAsValueBetweenPlusMinusOne, preferredPart);
        if(partAndUV.partname === null) {
            return result;
        }
        result.hitModel = true;
        result.position.u = partAndUV.u;
        result.position.v = partAndUV.v;
        result.part = partAndUV.partname;
        result.position.x = Math.round(result.position.u * this._modelParts[result.part].textureSize.x);
        result.position.y = Math.round(result.position.v * this._modelParts[result.part].textureSize.y);
        if(VIEWERFEATURE.LOG_HIT_PARTS_in_CONSOLE) {
            console.log("part hit by mouse: "+ result.part);
        }
        return result;
    }

    private getValuesToBeSavedBeforeSnapshot():{modelRotation, currentZoom, camera:{x,y}, selObs:[], containerStyle:{width, height}} {

        return {
            modelRotation : this.getModelRotation(),
            currentZoom   : this.zoomController.getFactor(),
            camera       : {
                x: this.camera.position.x,
                y: this.camera.position.y
            },
            selObs : [],
            containerStyle : {
                width:this.container.style.width,
                height:this.container.style.height
            }
        };
    }

    public getModelRotation():Vector2 {
        const rotation = this.modelObjects[0].rotation;
        return new Vector2(rotation.x, rotation.y);
    }

    private restoreSavedValuesAfterSnapshots(saved) {
        this.camera.position.y = saved.camera.y;
        this.camera.position.x = saved.camera.x;
        this.zoomController.setZoomLevel(saved.currentZoom);
        this.updateModelRotation(saved.modelRotation.x, saved.modelRotation.y);
        this.container.style.width = saved.containerStyle.width;
        this.container.style.height = saved.containerStyle.height;
    }

    private static degreeToRadialAngle = angle=>angle * 2 * Math.PI / 360;

    takeSnapshots(angles:number[]) : string[] {
        const saved = this.getValuesToBeSavedBeforeSnapshot();
        this.clearSelection();
        this.renderer.domElement.classList.add("fullscreen");

        this.camera.position.y = 0;
        this.camera.position.x = 0;
        this.zoomController.resetZoomLevel();
        this.calcViewSize(true);
        const tempImage = document.createElement("canvas");
        const tempCtx = tempImage.getContext('2d') as CanvasRenderingContext2D;
        tempImage.width = CONSTANTS.SNAPSHOT_HEIGHT /this.renderer.domElement.height  * this.renderer.domElement.width;
        tempImage.height = CONSTANTS.SNAPSHOT_HEIGHT;
        const pngArray = angles.map(a=>{
            this.updateModelRotation(0, OwayoJSKonfiViewer.degreeToRadialAngle(a));
            this.doRender(); //mit render() ist der neue Canvas Inhalt nicht sofort verfügbar (requestAnimationFrame)!
            tempCtx.drawImage(this.renderer.domElement,0,0,tempImage.width,tempImage.height);
            const out = tempImage.toDataURL();
            tempCtx.clearRect(0,0,tempImage.width, tempImage.height);
            return out;
        });
        this.restoreSavedValuesAfterSnapshots(saved);
        this.renderer.domElement.classList.remove("fullscreen");
        this.calcViewSize();
        this.render();
        return pngArray;
    }

    public escapeKeyReleased() {
        if (this.interactionMode === VIEWER_INTERACTIONMODES.WAIT_FOR_DROP) {
            this.selObController.deleteSelOb(this.waitingForDrop);
            this.waitingForDrop = "";
            this.interactionMode = VIEWER_INTERACTIONMODES.NONE;
        }
    }

    public selectedObjectIsMovable = ()=>this.selectedObject !== null && !this.selectedObject.isPinned;

    private static getTranslationParamaters(selectedObject:PartSelectableObject, operators:{x:string,y:string}, stepSize):{x:string, y:string} {
        const translationParams = {x:"", y:""};
        if (operators.x !== "") {
            translationParams.x = operators.x + selectedObject.getRelUVFromAbsUV_x(stepSize).toString();
        } else {
            translationParams.x = selectedObject.getRelUVFromAbsUV_x(selectedObject.translation.x).toString();
        }

        if (operators.y !== "") {
            translationParams.y = operators.y + selectedObject.getRelUVFromAbsUV_y(stepSize).toString();
        } else {
            translationParams.y = selectedObject.getRelUVFromAbsUV_y(selectedObject.translation.y).toString();
        }
        return translationParams;
    }

    public moveSelectedObjectByKeyboard(keyCode, stepSize) {
        const operators = ViewerKeyboardHandler.getXYOperators(keyCode);
        if(operators === null) {
            return;
        }
        this.selObController.changeSelOb((this.selectedObject as PartSelectableObject).id,
            {translation: OwayoJSKonfiViewer.getTranslationParamaters((this.selectedObject as PartSelectableObject), operators, stepSize)}
        );
    }

    public duplicateObjectByKeyboard() {
        let counterpart;
        if ((this.selectedObject as PartSelectableObject).cloneIds.length === 0) {

            counterpart = (this.selectedObject as PartSelectableObject).getParent().getCounterpart();
            if (counterpart) {
                this.selObController.prepareSelObDuplication((this.selectedObject as PartSelectableObject).id, counterpart);
            }
            return;
        }
        this.selObController.duplicateSelOb((this.selectedObject as PartSelectableObject).id);
    }

    private getNewModelRotationInDegreesFromNumpad(keyCode):Vector2 {
        const angleMap = ViewerKeyboardHandler.getKeyCodeAngleMapY(this.modelObjects[0].rotation.y);
        if(typeof(angleMap[keyCode]) === "undefined") {
            return this.getModelRotation().apply(v=>v / CONSTANTS.ONE_DEGREE);
        }
        return new Vector2(0, angleMap[keyCode]);
    }

    private getNewModelRotationInRadFromKeycode(keyCode, stepSize):Vector2 {
        let newRotations;
        if (ViewerKeyboardHandler.isRichtungsTaste(keyCode)) {
            newRotations = ViewerKeyboardHandler.getNewModelRotationInDegreesFromArrowKeys(this.getModelRotation(), keyCode, stepSize);
        } else {
            newRotations = this.getNewModelRotationInDegreesFromNumpad(keyCode);
        }
        return newRotations.apply(v=>v * CONSTANTS.ONE_DEGREE);
    }

    public rotateModelByKeyboard(keyCode, stepSize) {
        const newRotations = this.getNewModelRotationInRadFromKeycode(keyCode, stepSize);
        this.updateModelRotation(newRotations.x, newRotations.y);
    }

    openScreenshotWindow() {
        window.open(this.renderer.domElement.toDataURL("image/png")
            .replace("application/force-download", ""),"application/force-download", "Final");
    }

    onLoadedModel(objectMustBeCloned, model, cut, features) {
        const $this = this;
        this.features = features;
        this.utilityPainter.clearAllLayers();
        setTimeout(function(){$this.onLoadedModelAfterTimeout(objectMustBeCloned, model, cut);},5);
    }

    private createTeilungsLinienJSONTask(portalLinesJSON) {
        EventVerteiler.createTask("parseTeilungslinien")
            .discardAfterExecution()
            .when("designtexturesLoaded", "done")
            .thenDo(()=>this.teilungsLinienJSONLoaded(portalLinesJSON))
    }

    private teilungsLinienJSONLoaded(portalLinesJSON) {
        const portalLines = TeilungsLinienJSONParser.parseTeilungsLinienJSON(portalLinesJSON, this._modelParts);
        this.portalLines = this.portalLines.concat(portalLines);
        portalLines.forEach(l=>this.utilityPainter.snaps.splice(0,0, OwayoJSKonfiViewer.createSnapFromPortallinie(l)));
        this.checkObjectsAfterPortalLineLoad();
    }

    private loadTeilungslinienJSON(cut, model) {
        axios.get(encodeURI(CONSTANTS.MODEL_PATH + [cut, model, "teilungslinien.json"].join("/"))).then(response=>{
            this.createTeilungsLinienJSONTask(response.data)
        }).catch(()=>EventVerteiler.handleError("mild", "onloadedModel", "teilungslinien.json konnte nicht geladen werden"))
    }

    private static createSnapFromPortallinie(portalline:PortalLine):Snap {
        return new Snap(
            [portalline.portalLinieA.pointA, portalline.portalLinieA.pointB],
            "part",
            "middle",
            portalline.portalLinieA.partName,
            portalline.isVertical() ? "vertical" : "multiLine",
            "PortalLine"
        );
    }

    private static loadPartsJSON(model, cut) {

        return new Promise((resolve, reject) => {
            axios.get(CONSTANTS.MODEL_PATH + [cut, model, "parts.json"].join("/")).then(result=>resolve(result.data)).catch(reject);
        })
    }

    private onLoadedModelAfterTimeout(objectMustBeCloned, model, cut) {
        const $this = this;
        this.zoomController.resetZoomLevel();
        this.addObjectToScene(objectMustBeCloned);
        OwayoJSKonfiViewer.loadPartsJSON(model, cut).then((partsjson)=>{
            $this.setNichtEinfaerbbaresPartImageFlagTrueOnAllParts();
            PartJSONParser.parsePartsJSON(partsjson, $this._modelParts);
            SperrbezirkeJSONParser.loadSperrbezirkJSON(cut, model, $this._modelParts);
            $this.loadTeilungslinienJSON(cut, model);
            EventVerteiler.createTask("init_owayoJSViewer").when("entwurfInitialized", "done").thenDo(()=>$this.initModel());
            globalsObject.resourceManager.registerLoadedResourceWithoutData("owayoJSViewerWithSelObs_parts.json_Loaded", ResourceInvalidationTriggers.PRODUCTCHANGE)
        })
        //     .catch(()=>globalsObject.errorHandler.handleError(
        //     "fatal", "onLoadedModel",
        //     globalsObject.localizer.translate("konf_error_fileMissing")  + " (parts.json)"
        //     )
        // )
    }

    private initModel() {
        const data = this.controller.getLoadDesignData();
        this.isModelLoaded = true;
        this.interactionMode = VIEWER_INTERACTIONMODES.NONE;
        this.waitingForDrop = "";
        const zoomOrigin = this.zoomController.getZoomOrigin();
        this.moveCameraToPosition(zoomOrigin.x, zoomOrigin.y,this.camera.position.z, 0.5);
        this.zoomController.resetZoomLevel();
        this.loadDesign(data.design, data.model, data.schnitt, data.features, data.herstellerlogosEntfernt);
        this.initMaterials(
            this.owayoProductgetter.getCurrentOwayoProduct().partMaterials,
            this.owayoProductgetter.getCurrentOwayoProduct().selectedFeatures
        );
        EventVerteiler.createTask("insertSelobsAfterModelInit")
            .discardAfterExecution()
            .when("designtexturesLoaded", "done")
            .thenDo(()=> {
                const transferStorage = this.controller.getEntwurfTransferStorage();
                if(transferStorage.isProcessed === false) {
                    transferStorage.isProcessed = true; //damit sie nur einmal eingehängt wird
                    this.selObController.insertSelObsAfterProductChange();
                    this.patternController.insertPatternsAfterProductChange(transferStorage.patterns);
                } else {
                    this.selObController.selObInitialisationRequested();
                }
            });
    }

    protected createPart = (mesh:THREE.Mesh)=>new OwayoKonfiPart(this, mesh, this.zOrderTable);

    private static newScalingIsValid(newScaling : Vector2) : boolean {
        if (isNaN(newScaling.x) || isNaN(newScaling.y)) {
            return false;
        }
        return !(newScaling.x < CONSTANTS.MIN_SCALING || newScaling.y < CONSTANTS.MIN_SCALING);
    }

    /**
     * berechnet den neuen numerischen Wert.
     * valueExpr kann hierbei ein absoluter Wert sein oder mit "+=" bzw "-=" beginnen und somit
     * oldValue inkrementieren oder dekrementieren
     */
    public static computeNewNumberValue(valueExpr, oldValue):number {

        let mode = "absolute";
        if (typeof(valueExpr) === "string") {
            if (valueExpr.startsWith("+=")) {
                mode = "increment";
                valueExpr = valueExpr.substring(2);
            }
            if (valueExpr.startsWith("-=")) {
                mode = "decrement";
                valueExpr = valueExpr.substring(2);
            }
        }
        if (valueExpr !== "<none>") {
            valueExpr = parseFloat(valueExpr);
        }

        if (valueExpr !== "<none>" && isNaN(valueExpr)) {
            EventVerteiler.handleError("internal", "computeNewNumberValue", "error setting a number value");
            return NaN;
        }
        switch (mode) {
            case "absolute":
                return valueExpr;
            case "increment":
                return oldValue + valueExpr;
            case "decrement":
                return oldValue - valueExpr;
            default:
                EventVerteiler.handleError("internal", "computeNewNumberValue", "unkown mode " + mode);
                return -1;
        }
    }

    private static computeNewVector2(operator, vector:Vector2):Vector2 {
        return new Vector2(
            OwayoJSKonfiViewer.computeNewNumberValue(operator, vector.x),
            OwayoJSKonfiViewer.computeNewNumberValue(operator, vector.y)
        );
    }

    private changeSelObScaleUniform(id, operator, changeClones = true) {

        let partSelOb = this.getPartSelObById(id) as PartSelectableObject;
        if (partSelOb === null) {
            return;
        }

        const newValue = OwayoJSKonfiViewer.computeNewVector2(operator, partSelOb.scaling);
        if(!OwayoJSKonfiViewer.newScalingIsValid(newValue)) {
            return;
        }
        const cloneIds = partSelOb.cloneIds.slice(); //wir speichern hier die Klone. Klone die von checkPortalLinesForCloneCreation
        //erstellt weden haben bereits die neuen Werte!!
        partSelOb.scaling = newValue;
        partSelOb.updateCalculatedValues();

        let sizeInCm = partSelOb.getSizeInCm(newValue);
        this.selObController.relSizeCalculated(partSelOb.id, partSelOb.getRelSize(newValue), sizeInCm);

        this.utilityPainter.changeSnapsForSelOb(partSelOb);
        (partSelOb.shader as THREE.Shader).uniforms.selObMatrices.value[partSelOb.indexInShader] = partSelOb.getMatrixAbsCanvasFromAbsUV();
        this.checkPortalLinesForCloneDeletion(partSelOb);
        if (this.getPartSelObById(id) === null) {
            partSelOb = this.selectedObject as PartSelectableObject;
        } else {
            this.checkPortalLinesForCloneCreation(partSelOb);
        }
        if (changeClones) {
            for (let i = 0, lenI = cloneIds.length; i < lenI; i++) {
                const clone = this.getPartSelObById(partSelOb.cloneIds[i]);
                if (clone !== null) {
                    this.changeSelObScaleUniform(clone.id, operator, false);
                }
            }
        }
        partSelOb.placeAppropriateHandles();
        this.doSnapRepaint();
    }


    /**
     * liefert die exakten Dimensionen der Textobjekte sowie den wirklichen Mittelpunkt als Koordinate auf dem Canvas
     */
    getAllTextObjectRelUVDimensions():{id, width, height, actualMiddleCoordOnPart}[] {

        let part, output = [] as {id, width, height, actualMiddleCoordOnPart}[];

        for ( part in this._modelParts ) {
           output = output.concat(OwayoJSKonfiViewer.getBoundingBoxDataFromTextsInSelObArray(this._modelParts[part].selectableObjects));
        }
        return output;
    }

    private static getAllObjectRelUVDimensionsofTypeFromPart(part, typeNames) :Vector2[]{
        const output:Vector2[] = [];
        let i, lenI;
        const selectableObjects = part.selectableObjects;
        for (i = 0, lenI = selectableObjects.length; i < lenI; i += 1 ) {
            const partSelOb = selectableObjects[i];
            if (typeNames.indexOf(partSelOb.type) > -1) {
                output.push(partSelOb.getRelSize());
            }
        }
        return output;
    }

    /**
     * nur der Konsistenz wegen. Logos haben nicht das Problem, das Textobjekte haben...
     * @return {object}
     */
    private getAllObjectRelUVDimensionsofType(typeNames) {

        let part, output = [] as Vector2[];

        for ( part in this._modelParts ) {
            const modelPart = this._modelParts[part];
            output = output.concat(OwayoJSKonfiViewer.getAllObjectRelUVDimensionsofTypeFromPart(modelPart, typeNames));
        }
        return output;
    }

    getAllLogoObjectRelUVDimensions = ()=>this.getAllObjectRelUVDimensionsofType([SelObTypes.LOGO, SelObTypes.CHROMOLOGO, SelObTypes.STOCKLOGO]);

    private liftGreyOutOnNonDroppableParts = ()=>this.setNonDroppablePartsToGreyoutStatus(GreyOutState.NOT_GREYED_OUT);

    private setNonDroppablePartsToGreyoutStatus(value:GreyOutState) {
        this.withModelPartsDo((part:OwayoKonfiPart)=>{
            if (!this.partIsDropTarget(part)) {
                part.setGreyOutState(value);
            }
        });
        this.doRender();
    }

    private greyOutNotDroppableParts = ()=>this.setNonDroppablePartsToGreyoutStatus(GreyOutState.GREYED_OUT);

    private sendPartSizeInfoToController(callback) {

        const output = {};

        for ( const partName in this._modelParts ) {
            output[partName] = {
                x: this._modelParts[partName].partSizeCM.x,
                y: this._modelParts[partName].partSizeCM.y
            };

        }
        callback(output);

    }

    private tryInsertingSelObAfterProductChange(selOb:SelectableObject, oldPartDimensionsCm:Vector2, zIndex:number) {
        const valueCalculator = new SelObNewValueCalculatorafterProductChangeCalculator(this._modelParts);
        const valuesOnNewPart = valueCalculator.calculateNewSelObValuesOnNewParts(selOb, oldPartDimensionsCm);
        if (valuesOnNewPart !== null) {
            const newPart = this._modelParts[valuesOnNewPart.partName];
            selOb.partName = valuesOnNewPart.partName;
            selOb.translation.x = valuesOnNewPart.x;
            selOb.translation.y = valuesOnNewPart.y;
            selOb.relSize.x = selOb.relSize.x * oldPartDimensionsCm.x / newPart.partSizeCM.x;
            selOb.relSize.y = selOb.relSize.y * oldPartDimensionsCm.y / newPart.partSizeCM.y;
            this.selObController.insertSelObFromStorage(selOb, zIndex);
        }
    }

    private recreateAllShaders() {
        const $this = this;
        this.withModelPartsDo((part:OwayoKonfiPart)=>{
            if (!part.hasZentralesAbgelegtesNichtEinfaerbbaresPartImage) {
                part.handleShader = HandleShaderCreator.createHandleShader(part);
            }
            ShaderCreator.createShaders(part, $this.getPatterns(part.name));
        });
    }

    doABarrelRoll(angle = 0):void {
        const $this = this;
        if ($this.owayoProductgetter.getCurrentOwayoProduct().maxDrehungBogenmass < 2* Math.PI){
            return;
        }

        this.updateModelRotation(0, - angle * Math.PI / 180);
        angle += 5;
        this.render();
        if (angle > 360) {
            return;
        }
        setTimeout(function(){$this.doABarrelRoll(angle);}, 10);
    }

    public rotateToTargetAngleDegree(targetAngleDegree, guidRotating:string|null = null) {
        ModelRotatorSingleton.rotateModelToTargetAngleDegree(this, targetAngleDegree, guidRotating);
    }

    rotateRelVectorOnPart(relVec, partName, origAngleRad, cloneAngleRad):Vector2 {
        const part = this._modelParts[partName];
        const absVec = new Vector2(
            relVec.x * part.textureSize.x / part.partStauchungsFaktor,
            relVec.y * part.textureSize.y
        );
        const rotated = MathUtils.rotateVector(absVec, (origAngleRad - cloneAngleRad));
        return new Vector2(
            rotated.x / part.textureSize.x * part.partStauchungsFaktor,
            rotated.y / part.textureSize.y
        );
    }

    private nearestCloneToMousePositionOnPart(partSelOb:PartSelectableObject, partName, mousePosition) {
        const $this = this;
        let nearestDistance = Infinity, nearestClone:PartSelectableObject|null = null;

        if (partSelOb.getParentPartName() === partName) {
            const vec = new Vector2(partSelOb.translation.x - mousePosition.x,partSelOb.translation.y - mousePosition.y);
            nearestClone = partSelOb;
            nearestDistance = MathUtils.vectorLength2D(new Vector2(0,0), vec);
        }

        nearestClone = partSelOb.cloneIds.reduce(
            function(carry, id) {
                const clone = $this.getPartSelObById(id) as PartSelectableObject;
                if (clone.getParentPartName() === partName) {
                    const vec =  new Vector2(clone.translation.x - mousePosition.x, clone.translation.y - mousePosition.y);
                    const distance = MathUtils.vectorLength2D(new Vector2(0,0), vec);
                    if (distance < nearestDistance) {
                        nearestDistance = distance;
                        return clone;
                    }
                }
                return carry;
            },
            nearestClone
        );
        return nearestClone;
    }

    public doDblClick() {

        const result = this.getObjectDataFromMousePosition();
        let detailedResult, handle;

        if (result.part !== null ) {

            detailedResult = this._modelParts[result.part].getHitObjectAndColor(result.position);

            if (detailedResult.hitHandler !== null) {
                handle = this.getHandleFromPartAndId(result.part, detailedResult.hitHandler);
                EventVerteiler.broadcast("handleWasDoubleClickedEvent", {handleId: handle.id, selobId: handle.handleFor});
                return;
            }

            if (detailedResult.selectableObjectID !== null) {
                if (this.selectedObject === null || this.selectedObject.id !== detailedResult.selectableObjectID) {
                    this.setNewInteractionMode();
                }
                EventVerteiler.broadcast(SELOBEVENTNAMES.DOUBLECLICKED, detailedResult.selectableObjectID);
            }
        }
    }

    private hasNotDroppableParts():boolean {
        for (const part in this._modelParts) {
            if (this.partIsDropTarget(this._modelParts[part]) === false ){
                return true;
            }
        }
        return false;
    }

    public getColorCodeUnderPartSelOb(partSelObId: string) {
        const partSelOb = this.getPartSelObById(partSelObId);
        if (partSelOb === null) {
            return null;
        }
        const part = partSelOb.getParent();
        const translationXY = partSelOb.getRelativeTranslation(part.textureSize);

        return part.getHitColorCode({u: translationXY.x, v: translationXY.y});
    }

    private selectColorIfMouseOverColor() {
        let detailedResult;

        if (this.interactionMode !== VIEWER_INTERACTIONMODES.ROTATE) {
            return;
        }
        const result = this.getObjectDataFromMousePosition();
        if(result.part !== null) {
            detailedResult =  this._modelParts[result.part].getHitObjectAndColor(result.position);
            if (!detailedResult.hitHandler && detailedResult.selectableObjectID === null) {
                EventVerteiler.broadcast("colorSelectedEvent", {colorCode : detailedResult.colorCode});
            }
        }
    }

    calcViewSize(maxSize = false){
        let width, height;

        if(maxSize) {
                // noinspection JSSuspiciousNameCombination
            width = CONSTANTS.SNAPSHOT_HEIGHT;
                height= CONSTANTS.SNAPSHOT_HEIGHT;
        } else {
            if (this.container.offsetParent !== null) {
                const contentKonfiContainer =document.getElementsByClassName(".contentKonfi")[0];
                if(contentKonfiContainer !== undefined) {
                    this.container.parentElement.style.height = (document.getElementsByClassName(".contentKonfi")[0] as HTMLElement).style.height.toString()+"px"
                }
                width =   this.container.offsetParent.clientWidth;
                height = this.container.offsetParent.clientHeight;

            } else {
                width =  this.container.clientWidth ;
                height =  this.container.clientHeight;
            }
        }

        // if (this.container.offsetParent !== null) {
        //    const contentKonfiContainer =document.getElementsByClassName(".contentKonfi")[0];
        //    if(contentKonfiContainer !== undefined) {
        //        this.container.parentElement.style.height = (document.getElementsByClassName(".contentKonfi")[0] as HTMLElement).style.height
        //    }
        //     width =   this.container.offsetParent.clientWidth;
        //     height = this.container.offsetParent.clientHeight;
        //
        // } else {
        //     width =  this.container.clientWidth ;
        //     height =  this.container.clientHeight;
        // }

        this.dimensions.viewer.width = width;
        this.dimensions.viewer.height = height;

        this.renderer.setSize(width, height, true);
        this.camera.aspect = width / height;
        this.camera.updateProjectionMatrix();
        this.doRender();
    }

    private broadCastClearSelection = ()=>EventVerteiler.broadcast(SELOBEVENTNAMES.SELECTION_CLEARED);

    private calcModelPanning() {
        const offset = this.getContainerOffset();
        const oldPoint = this.get3DCoordinateAtZeq0(this.mouseController.getMouseInContainerOnClick(offset));
        const newPoint = this.get3DCoordinateAtZeq0(this.mouseController.getMouseInContainer(offset));
        const delta = new Vector2(newPoint.x - oldPoint.x, newPoint.y - oldPoint.y);

        this.camera.position.set(
            this.mouseController.mouseInfo.cameraPositionOnMouseDown.x - delta.x,
            this.mouseController.mouseInfo.cameraPositionOnMouseDown.y - delta.y,
            this.mouseController.mouseInfo.cameraPositionOnMouseDown.z
        );
        this.render();
    }

    /**
     * Berechnet aus Startposition der Maus und momentaner Endposition die neue Rotation des Modells
     * <strong>Achtung!!</strong>
     * Eine Bewegung der Maus auf der x-Achse führt zu einer Rotation <strong>um</strong> die Y Achse und umgekehrt!
     */
    private calcModelRotation(){
        const rotationOnMouseDown = this.mouseController.getRotationOnMouseDown();
        const mouseDeltaSinceClick = this.mouseController.getMouseDeltaSinceClick();
        const ratioToBogenMass = x=>x * 360 * CONSTANTS.ONE_DEGREE;
        const yAxisRotation = rotationOnMouseDown.y +   ratioToBogenMass( mouseDeltaSinceClick.x  / this.dimensions.viewer.width)
        const xAxisRotation = rotationOnMouseDown.x +   ratioToBogenMass( mouseDeltaSinceClick.y  / this.dimensions.viewer.height)
        this.updateModelRotation(xAxisRotation, yAxisRotation);
    }

    /**
     * Gibt die Koordinate der Maus in der 3d Welt zurück, wenn man z=0.5 annimmt
     */
    public get3DCoordinateAtZeq0(relativeCoordinates) {
        const vector = new THREE.Vector3(
            relativeCoordinates.x / this.dimensions.viewer.width * 2 - 1,
            - relativeCoordinates.y / this.dimensions.viewer.height * 2 + 1,
            0.5
        );
        vector.unproject( this.camera );

        const dir = vector.sub( this.camera.position ).normalize();
        const distance = - this.camera.position.z / dir.z;

        return this.camera.position.clone().add( dir.multiplyScalar( distance ) );
    }

    private static getNewpartSelectableObjectFromSelOb(selOb:SelectableObject, newObjectParameters) :PartSelectableObject{
        switch (selOb.type) {
            case SelObTypes.LOGO:
                return new PartSelectableObjectLogo(newObjectParameters);
            case SelObTypes.TEXT:
                return new PartSelectableObjectText(newObjectParameters);
            case SelObTypes.CHROMOLOGO:
            case SelObTypes.STOCKLOGO:
            default:
                newObjectParameters.svg = (selOb as ChromoLogo|StockLogo).currentSVG;
                return new PartSelectableObjectChromoLogo(newObjectParameters);

        }
    }

    private static getBoundingBoxDataFromTextsInSelObArray(selectableObjects:PartSelectableObject[]) {
        return selectableObjects.reduce(function(carry, partSelOb:PartSelectableObject) {
            if (partSelOb.type === SelObTypes.TEXT) {
                carry.push(partSelOb.getRelUVBoundingBoxData());
            }
            return carry;
        }, [] as {id, width, height, actualMiddleCoordOnPart}[]);
    }

    private static hidePreloader = ()=>{
        for(const item of document.getElementsByClassName("konfi-preloading")){
            item.classList.remove("konfi-preloading");
        }
    }

    private static showPreloader() {
        document.getElementsByClassName("main.konfi3DViewer")[0]?.classList.add("konfi-preloading");
        OwayoJSKonfiViewer.registerPreloaderHideTask();
    }

    public getDroppablePartNames(){
            return this.owayoProductgetter.getCurrentOwayoProduct().droppableParts.map(n=>owayoUtils.getCleanPartName(n));
                }

    public getDroppableParts = ()=>this.getDroppablePartNames()
        .map(n=>this._modelParts[n.replace(/ /g, "")])
        .filter(p=>typeof(p)!== "undefined");
    public getContainerOffset = ()=>{
        const canvas = this.container.getElementsByTagName("canvas")[0].getBoundingClientRect()
        return  {
            top: canvas.top + window.scrollY,
            left: canvas.left + window.scrollX,
        };

            // .offset() as {top, left};
    }

    public selectedObjectPresentButNotInitialized = ()=>typeof(this.selectedObject) !== "undefined" &&
        this.selectedObject !== null  &&
        this.selectedObject.textureSize.x === 0;

    public getPatterns(partname:string) {
        return this.patternController.getPatterns(partname);
    }

    public getPortalLines() {
        return this.portalLines;
    }
}
